export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 1.8599999999999999,
        "transcript": "...arnassagaurrniluku.",
        "translation": "...they say she's become an old lady."
    },
    "2": {
        "startTime": 1.94,
        "endTime": 8.39,
        "transcript": "Ellminek-gguq tarritellria angukara'urlurmek arrnassagarmek-llu aciyuitaat.",
        "translation": "They say they don't refer to one who can walk by themself as an old man or old woman."
    },
    "3": {
        "startTime": 8.39,
        "endTime": 15.27,
        "transcript": "Tau͡gaam angutngurtellriamek wall'u arnaurtellriamek-llu aterpagtelaraat...",
        "translation": "But call someon an old man or an old woman..."
    },
    "4": {
        "startTime": 15.275,
        "endTime": 23.11,
        "transcript": "Makut qanruyutait ciuliamta wangkuta qemagngangaicaaqaput elisngastaitni",
        "translation": "We who know them will not keep our ancestors' wisdom to ourself"
    },
    "5": {
        "startTime": 23.11,
        "endTime": 28.68,
        "transcript": "Akaarnun nunami maani nangengqatnguata.",
        "translation": "Because they help us stand here on earth for a long time."
    },
    "6": {
        "startTime": 29.07,
        "endTime": 34.47,
        "transcript": "Kenkek'ngaput-qaa tuquyararaasqaput wangkuta yup'ut?",
        "translation": "Do we want our people whom we love to have early deaths?"
    },
    "7": {
        "startTime": 34.475,
        "endTime": 41.835,
        "transcript": "Kenkekumteki makunek ciuliamta alerquutaitnek arcaqerluki qanrutarkaugaput.",
        "translation": "If we love them, we must tell them especially of our ancestors' traditional instructions."
    },
    "8": {
        "startTime": 41.86,
        "endTime": 52.64,
        "transcript": "Tuamta-llu wangkuta Yugni alerquutengqertukut yuullgutput tamalkuita elluarrluki ciuniuresqelluki",
        "translation": "Then, we Yupiit have the traditional instruction to warmly welcome all of our fellow people"
    },
    "9": {
        "startTime": 52.645,
        "endTime": 56.225,
        "transcript": "Allakaukevkenaki ilakuyulluta.",
        "translation": "We must cooperate without discriminating against them."
    },
    "10": {
        "startTime": 56.31,
        "endTime": 66.45,
        "transcript": "Kitumek, kinkut imkut Alaska-m yui tuaten umyuallgutekluteng ilakuyulluki nangengqasqumaut.",
        "translation": "Anyone, even the people of Alaska, are asked to stand with one mind in accordance."
    },
    "11": {
        "startTime": 66.955,
        "endTime": 75.145,
        "transcript": "Mat'um ilii, mat'um-am agayumacim ilait waten qanertut:",
        "translation": "Some of them here, some religions say this:"
    },
    "12": {
        "startTime": 75.145,
        "endTime": 79.84,
        "transcript": "\"Wangkuta agayumacirput assirtuq tukniluni-llu.\"",
        "translation": "\"Our religion is good and powerful.\""
    },
    "13": {
        "startTime": 79.84,
        "endTime": 84.44,
        "transcript": "Tuaten pinrituq. Tuaten ayuqenrituq.",
        "translation": "That's not the cast. That's not what it's like."
    },
    "14": {
        "startTime": 84.465,
        "endTime": 92.115,
        "transcript": "Ciuliamta ilakuyutiit navyunaicaaqerput wangkuta, piunriyunaunaku-llu.",
        "translation": "We shouldn't destroy our ancestors' tradition of community, and we shouldn't do away with it."
    },
    "15": {
        "startTime": 92.115,
        "endTime": 99.965,
        "transcript": "Una ilakuyun avaken ayagluni ciuliamta qanrutkaat kenkauguq.",
        "translation": "Our ancestors have spoken of this traditional of community, that it's a form of love starting from a long time ago."
    },
    "16": {
        "startTime": 100.165,
        "endTime": 109.48,
        "transcript": "Kenka atunrilkumteggu maani unguvallemteńi qaill' piluta anirtuumaciqceta? Allamek anirtuutaitukut.",
        "translation": "If we don't practice love while we're alive how, what will we do to be saved? We have no other salvation."
    },
    "17": {
        "startTime": 109.48,
        "endTime": 112.64,
        "transcript": "Ciuliamta kenka atullruat.",
        "translation": "Our ancestors practiced love."
    },
    "18": {
        "startTime": 112.645,
        "endTime": 122.035,
        "transcript": "Anirtuumaluteng-llu ayaumaluteng tamana atullruamegteggu yuullgutmeggnun tamalkuitnun allakaukutevkenateng.",
        "translation": "And they went in salvation because they practice that will all of their fellow people without discrimination."
    },
    "19": {
        "startTime": 122.165,
        "endTime": 132.575,
        "transcript": "Agayumacit ayuqenrilnguut allakaukucetaangraitkut tamana allakaukucaraq assiituq uitacurlagnaqluni-llu.",
        "translation": "Though different religions try to have us discriminate against each that, that discrimination is bad and leads to unrest."
    },
    "20": {
        "startTime": 132.655,
        "endTime": 141.625,
        "transcript": "Ciuliamta tau͡gaam alerquutiit ilakuyucaraq atuqumteggu nutaan uitanqegciluta nangengqaciqukut",
        "translation": "Only if we practice our ancestors' instruction of community will we stand [together] in peace"
    },
    "21": {
        "startTime": 141.625,
        "endTime": 144.655,
        "transcript": "Ukverput-llu qaqimalriaruluni.",
        "translation": "And our faith will be complete."
    },
    "22": {
        "startTime": 144.655,
        "endTime": 148.67,
        "transcript": "Tamaaggun-llu kenkekun anirtuumaarkauluta.",
        "translation": "And through that love, we shall be saved."
    },
    "23": {
        "startTime": 148.67,
        "endTime": 156.94,
        "transcript": "Makut maa-i wangkuta ciuliat makunun kinguliaramteńun arcaqerluku elisngavkararkauyaaqerput",
        "translation": "We must have our descendants especially be knowledgeable about our ancestors"
    },
    "24": {
        "startTime": 156.94,
        "endTime": 161.06,
        "transcript": "Mat'um-llu nunamta assirluku auluklerkaa.",
        "translation": "And how to take good care of our land."
    },
    "25": {
        "startTime": 161.705,
        "endTime": 169.155,
        "transcript": "Makut qanruyutet wangkuta nallunritestaini iirumatevkenaki.",
        "translation": "We who know this traditional wisdom shouldn't hide it."
    },
    "26": {
        "startTime": 169.165,
        "endTime": 173.065,
        "transcript": "Waten-gguq tang ciuliaput ayuqellrulriit:",
        "translation": "They say, you see, that our ancestors were like this:"
    },
    "27": {
        "startTime": 173.61,
        "endTime": 185.32,
        "transcript": "Qasgimi-gguq ayagyuaq tupagyarturnaurtuq ak'a tan'gerem iluani angukara'urluq qallaqurallinilria yuum elluarrluni yuullerkaanek.",
        "translation": "They said that in the community house, a young man would be waking up to an old man in the darkness already speaking about a person can live well."
    },
    "28": {
        "startTime": 185.32,
        "endTime": 192.05,
        "transcript": "Ayuqluku enemi-llu qakmani arnassagaq-gguq ak'a qallatelallinilria.",
        "translation": "The same way in a house out there, they said an old woman would already be speaking."
    },
    "29": {
        "startTime": 192.05,
        "endTime": 200.12,
        "transcript": "Tan'gerem iluani ukut kenkek'ngani qaneryaramun ayuqucirtuutmun-llu tupagtelluki.",
        "translation": "In the darkness, she let those she loved wake up to traditional wisdom and instruction."
    },
    "30": {
        "startTime": 200.12,
        "endTime": 205.84,
        "transcript": "Tuatnalartukut-qaa? Tuatnaksaitukut.",
        "translation": "Do we do that? We haven't done that."
    },
    "31": {
        "startTime": 206.725,
        "endTime": 214.315,
        "transcript": "Tamana ciuliamta ayuqucillrat wangkuta nangrutarkauyaaqaput makunun kinguliaramteńun.",
        "translation": "We must keep up what our ancestors were like to our descendants here."
    },
    "32": {
        "startTime": 214.315,
        "endTime": 221.075,
        "transcript": "Allakun anirtuutaitukut. Ilakuyutekun tau͡gaam anirtuutengqertukut.",
        "translation": "We have no other salvation. We only have salvation through community."
    },
    "33": {
        "startTime": 221.38,
        "endTime": 228.98,
        "transcript": "Atrallruuq Jesus-aaq ilakuyun tau͡gaam qaqicarturluku nunam qaingani tamiini.",
        "translation": "Jesus came down only to establish community among all the land."
    },
    "34": {
        "startTime": 229.165,
        "endTime": 231.675,
        "transcript": "Man'a-llu nallunrilkilaut:",
        "translation": "Let us know this:"
    },
    "35": {
        "startTime": 231.675,
        "endTime": 245.045,
        "transcript": "Tamatum-llu ilakuyutellemta nutaan elluarrluta yuullerkamteńek, pinillerkamteńek, unguvamallerkamteńek ayuqucirturarkauluta.",
        "translation": "And that sense of community of ours will teach us how to live well, be strong, and live long lives."
    },
    "36": {
        "startTime": 245.045,
        "endTime": 251.035,
        "transcript": "Angutuaruuq ciuliamta ilakuyulluteng nangengqallrat.",
        "translation": "It's a great thing how our ancestors stood [together] as a community."
    },
    "37": {
        "startTime": 251.035,
        "endTime": 258.635,
        "transcript": "Taumek agayumacit pinruningraitki ukveqevkenaki.",
        "translation": "That's why even if they say other religions are better, don't believe them."
    },
    "38": {
        "startTime": 258.76,
        "endTime": 269.76,
        "transcript": "Agayun atauciq pikanirviituq, angkanirviinani, aciqvaqanirviinani, nutem eluciqluku elucini.",
        "translation": "One God who has no potential for being exalter higher [among denominations], be greater, or lesser, who is always as he is."
    },
    "39": {
        "startTime": 269.765,
        "endTime": 273.955,
        "transcript": "Ataucimun Agayutmun ukvertukut Jesus-aamun-llu",
        "translation": "We believe in one God and in Jesus"
    },
    "40": {
        "startTime": 273.955,
        "endTime": 282.475,
        "transcript": "Pikanirviilngurmun, qulvaqanirviinani, piniqanirviinani-llu, elucini eluciqluku.",
        "translation": "To one who cannot be exalted higher [among denominations], be higher, or stronger, who is always as he is."
    },
    "41": {
        "startTime": 282.475,
        "endTime": 293.165,
        "transcript": "Tamana pitekluku wangkuta Yugni ilakuyun tau͡gaam ayagniutnaurput arcaqerluku makunun kingunemteńun.",
        "translation": "For that reason, let us Yupiit start this sense of community, especially with our descendants."
    },
    "42": {
        "startTime": 293.165,
        "endTime": 297.755,
        "transcript": "Una ayagyuaq waten ayuquq mat'um nalliini:",
        "translation": "A youth here is like this these days:"
    },
    "43": {
        "startTime": 298.125,
        "endTime": 304.42,
        "transcript": "Kass'acetun qaneryaurtaqami umyugaa quyigilartuq elisngalriaruyukluni.",
        "translation": "When [s]he learns to speak English, they become proud thinking they're smart."
    },
    "44": {
        "startTime": 304.42,
        "endTime": 310.44,
        "transcript": "Amta-llu yuullerkaq nalluluku, au͡gna-llu tekitellerkani nalluluku.",
        "translation": "And yet [s]he doesn't know how to survive, and doesn't know what they will come to."
    },
    "45": {
        "startTime": 310.445,
        "endTime": 322.885,
        "transcript": "Makut maa-i wangkuta makunun ayagyuamteńun paivulluki elisngavkararkauyaaqerput au͡gna ciuliamta yuullra",
        "translation": "We must make available to our youth and have them be knowledgeable about our ancestors' way of life"
    },
    "46": {
        "startTime": 323.64,
        "endTime": 326.74,
        "transcript": "Ilakuyutellrat arcaqerluku.",
        "translation": "Especially their sense of community."
    },
    "47": {
        "startTime": 326.745,
        "endTime": 333.385,
        "transcript": "Waten pitalriamek amllenrilengraan qanqertua. Quyana.",
        "translation": "I've [come to] say this much though it wasn't a lot. Thank you."
    },
    "48": {
        "startTime": 626.747,
        "endTime": 629.817,
        "transcript": "Imkut tua-i carrarmek qanlalriit.",
        "translation": "Those people speak little."
    },
    "49": {
        "startTime": 630.137,
        "endTime": 632.997,
        "transcript": "Waqaa? Tua-i-q' ayagnirnariuq? (Yaa.)",
        "translation": "What's goin on? Is it time to start? (Yes.)"
    },
    "50": {
        "startTime": 633.182,
        "endTime": 639.592,
        "transcript": "Kitaki'urluq tua-i waniwa qanqernaurtukuk.",
        "translation": "Okay then, let's talk now."
    },
    "51": {
        "startTime": 640.272,
        "endTime": 646.252,
        "transcript": "Ii-i, tua-i imumi cumigyagutellemni-ll' wiinga",
        "translation": "Yes, a long time ago, and when I became observant"
    },
    "52": {
        "startTime": 646.997,
        "endTime": 654.732,
        "transcript": "Ellangamta tua-i maaten ellangukut tamakut-llu au͡g'um ava-i qanrutkellri aiparma niiskengaqluki.",
        "translation": "We became aware in our early childhood, and we heard about those that my spouse just talked about."
    },
    "53": {
        "startTime": 654.732,
        "endTime": 661.042,
        "transcript": "Tau͡gaam tua-i wangkutni ayagyuani tua-i alingnaqluteng tamakut Kass'aqarraat.",
        "translation": "But for us young people, those first Caucasians were scary."
    },
    "54": {
        "startTime": 661.042,
        "endTime": 665.032,
        "transcript": "Qavcin tua-i Kass'at tangerqalaqput.",
        "translation": "We'd occassionally see several Caucasians."
    },
    "55": {
        "startTime": 665.992,
        "endTime": 673.092,
        "transcript": "Nakelguyugnaunaki caqapkacagaqamta tekitellriani Kass'anek tangerqaqluta.",
        "translation": "Absolutely without [?] them, when they came once in a great while, we'd see Caucasians."
    },
    "56": {
        "startTime": 674.177,
        "endTime": 675.512,
        "transcript": "Tamakut tamaa-i.",
        "translation": "There were those."
    },
    "57": {
        "startTime": 675.512,
        "endTime": 683.162,
        "transcript": "Tua-i-ll' piqerluteng maani Anuuraami uitaluta elitnaurvingluteng maani.",
        "translation": "Then one day when we were living here in Anuuraaq, they built a school here."
    },
    "58": {
        "startTime": 683.162,
        "endTime": 687.802,
        "transcript": "Takuk'acagamteńi elitnaurvingluteng, ayumian-ll' elitnaungluteng.",
        "translation": "They built a school right in the middle of us, then they started going to school."
    },
    "59": {
        "startTime": 688.117,
        "endTime": 697.307,
        "transcript": "Tua-i-llu tua-i elitnauryassaagyaaqelriakut. Tamakut angayuqamta qunukekaca'arluta.",
        "translation": "Then we tried going to school. Our parents didn't want to part with us."
    },
    "60": {
        "startTime": 697.807,
        "endTime": 701.887,
        "transcript": "Angurrluk' elitnauryaasqevkenata tamakut.",
        "translation": "They told us not to go to school whatsoever."
    },
    "61": {
        "startTime": 702.842,
        "endTime": 710.242,
        "transcript": "Camek tua-i akusrarrnarqelriamek ayagniriniluku. Maa-i tua-i ungacautnguniluki tamakut elitnaurviit.",
        "translation": "They said that it starts something mischievous. Now, they said that those schools make them coddled."
    },
    "62": {
        "startTime": 710.877,
        "endTime": 715.832,
        "transcript": "Alingnaqkacagarluteng tua-i tuani pillemteńi inerquaratkut.",
        "translation": "They were scary back when we went because they admonished us."
    },
    "63": {
        "startTime": 715.832,
        "endTime": 722.362,
        "transcript": "Elitnauryaryaaqerraarlua-ll' wii ataucirqumek tua-i paq'e'rcaaqerraarlua...",
        "translation": "And after I tried going to school, after I tried going to them once..."
    },
    "64": {
        "startTime": 722.372,
        "endTime": 725.182,
        "transcript": "Wait, tauna igtuq.",
        "translation": "Wait, that fell."
    },
    "65": {
        "startTime": 730.042,
        "endTime": 732.372,
        "transcript": "Aipaqlian?",
        "translation": "Is he your spouse?"
    },
    "66": {
        "startTime": 733.122,
        "endTime": 735.642,
        "transcript": "Qastussiyaallemta pillia.",
        "translation": "It might be because we were too loud."
    },
    "67": {
        "startTime": 735.647,
        "endTime": 736.697,
        "transcript": "Nuu.",
        "translation": "No."
    },
    "68": {
        "startTime": 739.167,
        "endTime": 745.642,
        "transcript": "Tua-i-llu elitnauryaryaaqerraarluta uitasqeńgatkut uterrluta tua-i.",
        "translation": "Then after we tried going to school, since they told us to stay, we went home."
    },
    "69": {
        "startTime": 745.642,
        "endTime": 753.082,
        "transcript": "Makut-wa tua-i qanerturalriit, \"Makut-gguq elitnaurviit arenqiatut.\"",
        "translation": "These people kept saying, \"These schools are distressing.\""
    },
    "70": {
        "startTime": 753.397,
        "endTime": 756.932,
        "transcript": "Avani tua-i iqugglungqertut akusrarrluteng.",
        "translation": "Later, their mischief will have bad outcomes."
    },
    "71": {
        "startTime": 756.932,
        "endTime": 762.622,
        "transcript": "Usviiruciiqut-gguq avani yaaqvaarni tua-i callerkameggnek umyuarteqenrirluteng",
        "translation": "They said they'd become foolish far in the future, not thinking of what chores they should be doing"
    },
    "72": {
        "startTime": 762.622,
        "endTime": 767.372,
        "transcript": "Mat'umek akusrarutnek taitengkata tua-i.",
        "translation": "When they start bringing in these mischievous things."
    },
    "73": {
        "startTime": 768.672,
        "endTime": 775.092,
        "transcript": "Tua-i elitnaurpek'nata, makut tau͡gaam ayagyuarluut tua-i irniaput-llu elitnaungluteng.",
        "translation": "We didn't go to school, but these poor young people and our children started going to school."
    },
    "74": {
        "startTime": 775.117,
        "endTime": 779.237,
        "transcript": "Cat nallunrilngluku tua-i igautaqluta-llu.",
        "translation": "They started knowing things and wrote for us."
    },
    "75": {
        "startTime": 780.382,
        "endTime": 786.152,
        "transcript": "Tamakut tamaa-i Kass'at tuaten... qaillun-llu Kass'anek nangciksailnganateng.",
        "translation": "Even those Caucasians... and they didn't seem to mistreat Caucasians in any way."
    },
    "76": {
        "startTime": 786.152,
        "endTime": 792.132,
        "transcript": "Tau͡gaam tamakut angalkut-llu caliarit tamakut tuaten ayuqellruluteng.",
        "translation": "But the work of those shamans were also like that."
    },
    "77": {
        "startTime": 793.217,
        "endTime": 798.587,
        "transcript": "Anglanitekluki tamakut piaqluki umyuarrliqngameng tua-i.",
        "translation": "They would have fun [causing mischief] with them because they had malicious intent."
    },
    "78": {
        "startTime": 798.587,
        "endTime": 809.537,
        "transcript": "Man'a-w' call' akuliitni, qanruyuterugaita imkut qanrutestemta akuliitni piyulria qanruyutem tua-i ilakluku.",
        "translation": "And among them here, among the many pieces of traditional wisdom from our instructors, one who wanted to [cause mischief] was part of the traditional wisdom."
    },
    "79": {
        "startTime": 809.537,
        "endTime": 812.087,
        "transcript": "Ciknayaraq-gguq man'a",
        "translation": "They said that jealousy"
    },
    "80": {
        "startTime": 812.757,
        "endTime": 822.177,
        "transcript": "Yuk-gguq elluarrluni yuungnaqura'urlulria ciknakluku imna angalkum ciknatarlim",
        "translation": "They said that out of a joulesy of a poor person making their own living, a jealous shaman"
    },
    "81": {
        "startTime": 822.442,
        "endTime": 831.462,
        "transcript": "Pinrillugcetaarluku picuirucetaqluku wall'u tukuuyullallrat man'a navgaqluku elluarrluteng yuuqataryaaqellrit.",
        "translation": "[S]he places a curse on him to make him unable to catch animals, or destroys the great wealth of one who was going to live well."
    },
    "82": {
        "startTime": 831.467,
        "endTime": 834.367,
        "transcript": "Umyuarrliqluteng tamakut cakneq.",
        "translation": "Those had very malicious intent."
    },
    "83": {
        "startTime": 834.752,
        "endTime": 841.602,
        "transcript": "Tua-i-llu cali qanruyutet makut",
        "translation": "Then these pieces of traditional wisdom"
    },
    "84": {
        "startTime": 841.932,
        "endTime": 850.812,
        "transcript": "Ilameng-gguq akuliitnii ik'ikengraitkut tua-i qessamkaukluta-ll' ayagyuarlurni",
        "translation": "They said that among the people around them, though they find us poor young people improper or lazy"
    },
    "85": {
        "startTime": 850.817,
        "endTime": 861.167,
        "transcript": "Nasaurlullraullemni maani unugmi-llu, aanairucarallruama-ll' wii unugmi-llu tan'geriaqan anenermek taq'laama",
        "translation": "When I was a girl here, at night, and since I lost my mother at a young age, because I would stop going out at night when it got dark"
    },
    "86": {
        "startTime": 862.537,
        "endTime": 869.987,
        "transcript": "Akeqnerrluggnauraatnga makut qessamkaukuma tua-i waten kaigasteńguciqnilua.",
        "translation": "These people would threaten me that if I were a lazy person, that I would be a begger like this."
    },
    "87": {
        "startTime": 871.017,
        "endTime": 880.837,
        "transcript": "Picurlautek'larciqniluku-ll' tamana qessamkaulua pirraarlua ilanka uingequkata ayuqniam ugaani.",
        "translation": "And they said that that [begging] would bring me misfortune after I was lazy when my peers took husbands, out of [my] desire to have things like them."
    },
    "88": {
        "startTime": 884.502,
        "endTime": 890.702,
        "transcript": "Tau͡gaam tua-i tuaten qanrutaqluta makut wani qanenqegcaarautestemta.",
        "translation": "But our thorough instructors would tell us that."
    },
    "89": {
        "startTime": 890.707,
        "endTime": 903.527,
        "transcript": "Ilamta akuliitni-ll' ellalkartevkenata, [?imumek aa]piirtevkenata, murilkevlacagpek'nata, usviitevkenata ilamta akuliitni.",
        "translation": "And among our peers, we shouldn't misbehave, shouldn't [? as you know], shouldn't be inadequately observant, shouldn't be fooling among our peers."
    },
    "90": {
        "startTime": 905.162,
        "endTime": 909.492,
        "transcript": "Maktaqameng tua-i qanruqu'urnauraitkut",
        "translation": "When they got up, they'd always tell us"
    },
    "91": {
        "startTime": 909.492,
        "endTime": 919.352,
        "transcript": "\"Elpeci-ll' maa-i ayagyuani irniangekuvci-gguq irniarci-gguq mikelnguungalnge'rmi wall' pilukuvceńi camek inerququvciu",
        "translation": "\"When you young people have children, though your child seems small, or if you admonish them when you put on their boots"
    },
    "92": {
        "startTime": 919.357,
        "endTime": 924.772,
        "transcript": "\"'Kitak' at' ilaten piqaqatgen qimagaqluki ingluliuqina.'",
        "translation": "\"'Now, if your peers do anything to you, respond by getting away from them.'"
    },
    "93": {
        "startTime": 924.772,
        "endTime": 926.782,
        "transcript": "Atam-gguq cumikeyagatuut.",
        "translation": "They said the little ones pay attention."
    },
    "94": {
        "startTime": 926.782,
        "endTime": 936.202,
        "transcript": "Tua-i-gguq maa-i makut maa-i ciulirnemta makut tamana ellangeqarraallermeggni niitellerteng tua-i pikluku.",
        "translation": "They said that these things our elders heard in their earliest memories are theirs [to remember and pass on]."
    },
    "95": {
        "startTime": 940.557,
        "endTime": 948.657,
        "transcript": "Maa-i tua-i tamana umyuaqaqamku qunukelalqa-llu tamana akusrarciiqniluki avani",
        "translation": "Now, when I remember that, and how I was reluctant to accept that they'd become more mischievous later"
    },
    "96": {
        "startTime": 949.142,
        "endTime": 955.602,
        "transcript": "Qitevcuilama-llu qitevtellrit-llu niicuilamki umyuaqluki.",
        "translation": "And since I didn't speak English, and didn't hear them speak English, I remembered them."
    },
    "97": {
        "startTime": 955.607,
        "endTime": 959.217,
        "transcript": "Irniangamegnuk-ll' aipangamegnuk",
        "translation": "And when we had children, when we got married"
    },
    "98": {
        "startTime": 961.817,
        "endTime": 970.587,
        "transcript": "Aipaput kenekluki pisqessaaqaqluki, uiput cumikluki.",
        "translation": "They told us to treat our spouses with love, take care of our husbands."
    },
    "99": {
        "startTime": 970.587,
        "endTime": 972.737,
        "transcript": "Allaliuqsaunata-llu.",
        "translation": "And we shouldn't commit adultery."
    },
    "100": {
        "startTime": 972.737,
        "endTime": 980.612,
        "transcript": "Uimta-llu nalluatni arnaurlulriani wangkuta ayagallerkartuyarrluta",
        "translation": "And if we poor woman go to various places without our husbands' knowledge"
    },
    "101": {
        "startTime": 980.612,
        "endTime": 985.952,
        "transcript": "Kiituani-gguq taum uimta pikenrilkiinek qingangaqluta-gguq.",
        "translation": "They said that eventually, we'd become pregnant with someone other than our husbands."
    },
    "102": {
        "startTime": 985.957,
        "endTime": 997.112,
        "transcript": "Imkut maaten tamaani ellangeqarraallemteńi qanrutaqamegtekut iki'uk'acagangraan ca ikuggluku qanrutnauraitkut.",
        "translation": "Back when in our childhoods, we found that when they instructed us, no matter how socially unacceptable it was, they'd pry it out and tell us."
    },
    "103": {
        "startTime": 997.112,
        "endTime": 1003.332,
        "transcript": "Tangvagluta-ll' piaqatkut waten umyuarteqsaaqnaurtukut wangkuta niicugnilriani:",
        "translation": "And when they looked at us, we who were listening would think like this:"
    },
    "104": {
        "startTime": 1003.337,
        "endTime": 1008.852,
        "transcript": "\"Aling, ik'um-am cunaw' nallunrilkiikut, tangellrukiikut.\"",
        "translation": "\"Oh my, it turns out the one across know knows us, has seen us.\""
    },
    "105": {
        "startTime": 1008.852,
        "endTime": 1013.792,
        "transcript": "Tuar tang nallunritkacagarluta, ilumun tangellruluta pilaqaitkut.",
        "translation": "It seemed they knew everything about us, like they'd indeed seen us."
    },
    "106": {
        "startTime": 1014.887,
        "endTime": 1021.482,
        "transcript": "Cunaw' tamakut qanruciyupialriit ircaqurteng cairluteng ellaita atullmeggnek.",
        "translation": "It turned out that those who instructed well would empty their heard of what they'd experienced."
    },
    "107": {
        "startTime": 1021.482,
        "endTime": 1027.662,
        "transcript": "Assirluku yuk agesqelluku qanruturlularyaaqellinikaitkut.",
        "translation": "The dear ones would instruct us, wanting a person to go [through life] well."
    },
    "108": {
        "startTime": 1027.662,
        "endTime": 1035.682,
        "transcript": "Irniau͡rluput-llu waten makut irniaqsagutaqamteki angurrluk' tua-i agutevkenaki.",
        "translation": "And when we bear children, they told us never to bring them to various places [with people]."
    },
    "109": {
        "startTime": 1035.687,
        "endTime": 1042.062,
        "transcript": "Tass'uqluki-ll' enenun allanun ceńirtaaruqu'urqata assiiruturlurniartut.",
        "translation": "And if we hold their hands to visit other houses with them, the dear ones will become bad."
    },
    "110": {
        "startTime": 1042.062,
        "endTime": 1050.162,
        "transcript": "Ikiurlullrat man'a arrsaurlullerqut ilalqerluku-gguq atam aanaulriami enem nayurtiini.",
        "translation": "They say their improper behavior exacerbates a mother's destitution who looks after the home."
    },
    "111": {
        "startTime": 1050.167,
        "endTime": 1055.322,
        "transcript": "Una-wa-gguq aatavut ayagalria pikangengnaqluta.",
        "translation": "They said our household's father would travel to try to provide for us."
    },
    "112": {
        "startTime": 1055.322,
        "endTime": 1062.742,
        "transcript": "Pitarra'urlui-gguq tekitaqan quyatekluki ciuniurluki arnaulriani.",
        "translation": "They said that when he arrives, we women should be thankful for whatever he catches."
    },
    "113": {
        "startTime": 1063.327,
        "endTime": 1072.937,
        "transcript": "Wall' akirrarmek unangekan qenngevkenata wangkuta arnani taqmakegciyugluta wall' camek cap'akiqegciyugluta.",
        "translation": "Or if he earns a little money, we women shouldn't be angry wanting beautiful dresses or some beautiful shoes."
    },
    "114": {
        "startTime": 1072.937,
        "endTime": 1078.647,
        "transcript": "Aturaqegciamta-gguq tua-i, pikarciaritnek maa-i nangerngiimta.",
        "translation": "They said it's because we have nice clothes, because we're standing with what they provided."
    },
    "115": {
        "startTime": 1078.837,
        "endTime": 1085.387,
        "transcript": "Tamakut-gguq navguutekai taum, aipamteńun.",
        "translation": "They say those will destroy our spouses."
    },
    "116": {
        "startTime": 1085.687,
        "endTime": 1096.037,
        "transcript": "Tamakut unangkengarait, uiu͡rlumta unangkengarait munarulluki-gguq munarcallrani tauna aipa'urluput ukisqirluki.",
        "translation": "What little they obtain, they said we should be dextrous with what little they obtain, helping our dear spouses."
    },
    "117": {
        "startTime": 1096.037,
        "endTime": 1099.807,
        "transcript": "Tamakut tamaa-i anglanitekevkenaki-gguq.",
        "translation": "They said not to be frivolous with them."
    },
    "118": {
        "startTime": 1099.807,
        "endTime": 1103.162,
        "transcript": "Akingutaurluinek tegulerulluta ayagpek'nata.",
        "translation": "We shouldn't grab what money he made and go."
    },
    "119": {
        "startTime": 1103.162,
        "endTime": 1110.352,
        "transcript": "Avani-ll' ayainanemteńi canun akusrarrnarqelrianun tekiskumta wall' mer'aluta wall' canek",
        "translation": "And later as we go, if we come across mischievous things, or we drink, or other things"
    },
    "120": {
        "startTime": 1111.112,
        "endTime": 1121.112,
        "transcript": "Inerqurluta tua-i tamalkuita tamakunek aarnarqellriamek irniamta takuatni tuaten ayuqesqevkenata. Alerquaciqaput-gguq.",
        "translation": "They admonished us against all of those dangerous things, not to be like that in front of our children. They said we'd teach them [how to be like that]."
    },
    "121": {
        "startTime": 1121.117,
        "endTime": 1127.327,
        "transcript": "Cunaw' imna anguyagteńun ayagangaqameng, tan'gaurlurugaumeng-ll' irniapuk",
        "translation": "It turned out that when they got enlisted en masse, and since we have a lot of male children"
    },
    "122": {
        "startTime": 1127.327,
        "endTime": 1133.057,
        "transcript": "Tua-i umyuaq una navgurluku yuungaqluta [?meryuu]llermegteggun maaggun.",
        "translation": "We start living with a hopeless mindset because they [?tended to drink]."
    },
    "123": {
        "startTime": 1133.307,
        "endTime": 1142.122,
        "transcript": "Tua-i tuaten tau͡gaam ilalqerpek'nani yuk yuurluqili mat'um nalliini.",
        "translation": "May a person live like that without exacerbating anything these days."
    },
    "124": {
        "startTime": 1142.122,
        "endTime": 1145.762,
        "transcript": "Tamana-llu tamaa-i akerrneqlugutek'lallrat",
        "translation": "And their warning of a terrible ending"
    },
    "125": {
        "startTime": 1145.767,
        "endTime": 1153.477,
        "transcript": "Akusrangkumta-gguq, tamakut angayuqamta, qanrutestemta, ciulirnemta qanrutaqamegtekut",
        "translation": "They said that if we start being mischievous, when our parents, instructors, and elders instructed us"
    },
    "126": {
        "startTime": 1153.477,
        "endTime": 1157.972,
        "transcript": "Akusrangkumta-gguq camek elpek['ngaaru]lluta.",
        "translation": "They said that if we become mischievous, we [won't] be sensible anymore."
    },
    "127": {
        "startTime": 1157.972,
        "endTime": 1167.662,
        "transcript": "Qanrutestevvut cumikenrirluku, alerquastevvut elluarrluta yuusqelluta aviranaunata ilamta akuliitni.",
        "translation": "We don't pay any more attention to our advisor, our instructor, who tells us to live right, without being a hindrance among those around us."
    },
    "128": {
        "startTime": 1167.872,
        "endTime": 1177.652,
        "transcript": "Tau͡gaam-gguq assirluta tangniqluta enemteńi aqumluta, enevut-gguq uitanqegcinaqniartuq.",
        "translation": "Instead, they said that we would do well to look presentable sitting at home, so, they said, that our home would be peaceful."
    },
    "129": {
        "startTime": 1177.657,
        "endTime": 1187.752,
        "transcript": "Allaneruaraam-llu nanikualriim itervikekakut uitanqegcivkangnaqluku im'uvkenata, akusrartevkenata yuukumta.",
        "translation": "And if some guest who feels helpless comes in, we should make them feel at peace if we don't, you know, live mischievously."
    },
    "130": {
        "startTime": 1187.752,
        "endTime": 1198.452,
        "transcript": "Tua-i tuaten qanraqata piyugyaaqengramta, amta-llu tua-i iliini canun tekitengaqluta tua-i.",
        "translation": "When they said that, though we wanted to [be like that], yet we'd sometimes come across [extrenuating] circumstances."
    },
    "131": {
        "startTime": 1199.317,
        "endTime": 1203.612,
        "transcript": "Assiryugyaaqellerput man'a ukatairluku.",
        "translation": "We're unsuccessful when we wanted to be good."
    },
    "132": {
        "startTime": 1203.612,
        "endTime": 1211.112,
        "transcript": "Ukut-llu maa-i waten makutgun qanruciarkanek kepqengata",
        "translation": "And because these people are now in great need of instructors like this"
    },
    "133": {
        "startTime": 1211.117,
        "endTime": 1221.227,
        "transcript": "Ayagyuat makut wani kinguqliput maa-i mat'um nalliini yuut amlleriata alerquatmek niicungata",
        "translation": "These young people, our descendants, because there's now a lot of people who want to hear traditional instructions"
    },
    "134": {
        "startTime": 1221.227,
        "endTime": 1223.962,
        "transcript": "Taumek tang tua-i capqerqelaqeka.",
        "translation": "That's why I'm daunted by it."
    },
    "135": {
        "startTime": 1223.962,
        "endTime": 1232.972,
        "transcript": "Angliriluta tua-i waten niicugniarkauyaaqekput qanruyutiit elluarrluku.",
        "translation": "When we're grown like this, we're supposed to listen well to their traditional wisdom."
    },
    "136": {
        "startTime": 1232.972,
        "endTime": 1243.852,
        "transcript": "Imkut ak'a ayagningellruyaaqngata 'gguun KYUK-kun qanelriit imkut, arnat-llu alerquagiluteng.",
        "translation": "I've already started through here on KYUK, with those who are instructing, and those women giving traditional instruction."
    },
    "137": {
        "startTime": 1243.857,
        "endTime": 1254.367,
        "transcript": "Tamakut-llu tamaa-i arnat uingit[lermeggni] taur caunrilkellermegteggu ciisqurrilitaqluki.",
        "translation": "And those, when women didn't have husbands, when they didn't think anything of it, it was their kneeguards."
    },
    "138": {
        "startTime": 1254.367,
        "endTime": 1261.737,
        "transcript": "Tamaaggun ayuqenrilngurnek-llu irniangeksaunata, uiu͡rlurput tau͡gaam nakmiillarput.",
        "translation": "Through that, we didn't have children with various [fathers], except through our very own dear husbands."
    },
    "139": {
        "startTime": 1261.947,
        "endTime": 1271.002,
        "transcript": "Aipamta-gguq tau͡gaam tamakunek irniarinek irniarluta canek allatarnek ilayuunaki.",
        "translation": "They said we should have our spouses' children without adding any from other [people]."
    },
    "140": {
        "startTime": 1271.002,
        "endTime": 1273.852,
        "transcript": "Tangniqpiarluteng-gguq.",
        "translation": "They said they were very beautiful [families]."
    },
    "141": {
        "startTime": 1274.082,
        "endTime": 1278.852,
        "transcript": "Ayuqniau͡rluryaaqnaurtua, aling arenqiapaa-ll'.",
        "translation": "Poor me, I would wish for that, oh my goodness."
    },
    "142": {
        "startTime": 1279.212,
        "endTime": 1286.992,
        "transcript": "Cunaw' tua-i nallumteńi-ll' tua-i tayima tua-i qingircetnayukluta.",
        "translation": "Apparently, we might have accidentally gotten pregnant."
    },
    "143": {
        "startTime": 1286.997,
        "endTime": 1294.132,
        "transcript": "Ayagyuarluta-ll' qingircetlerkaq tua-i alingnaqkacagarluni, mikelngurmek alairillermek.",
        "translation": "And the thought of becoming pregnant at a young age was very scary, bringing forth a child."
    },
    "144": {
        "startTime": 1294.132,
        "endTime": 1299.642,
        "transcript": "Aatailnguut tallurnaqkacagarluteng-gguq. Inerquutnguyaaqluni.",
        "translation": "They said children out of wedlock were very embarrassing. It had been an admonishment."
    },
    "145": {
        "startTime": 1299.642,
        "endTime": 1306.102,
        "transcript": "Maa-i tamatuullinill' akusrangllerkaatnek qanlallrat imkut au͡gkut ciuliamta.",
        "translation": "Apparently, that was how they'd become mischievous as our ancestors talked about."
    },
    "146": {
        "startTime": 1306.827,
        "endTime": 1310.497,
        "transcript": "Tamana tamaa-i alerquuterpaksaaqekiit maa-i.",
        "translation": "That is an important instruction they have now."
    },
    "147": {
        "startTime": 1310.497,
        "endTime": 1318.627,
        "transcript": "Makut tua-i Kass'at maa-i assipiat. Aling niitniqpiat, ungaqtarnaqpiat Kass'at.",
        "translation": "These Caucasians are so good. Oh my, they sound nice, these Caucasians are pleasant."
    },
    "148": {
        "startTime": 1319.477,
        "endTime": 1331.372,
        "transcript": "Tangvagaqamta, tangercetaanek-llu tangvagaqamta canek-llu au͡gkut inerciigalnguut arnat-llu kap'urluraqaceteng qaillurayak elli'irrnaurtut.",
        "translation": "When we watch them, and when we watch showsand other things, when they inject rowdy people and women, they'd become very strange."
    },
    "149": {
        "startTime": 1331.372,
        "endTime": 1337.562,
        "transcript": "Unaqsarrluteng, camek tua-i tuar tua-i eyautairtelalriit wangni.",
        "translation": "They would become like, and to me, it seemed they had no more rigidity."
    },
    "150": {
        "startTime": 1337.642,
        "endTime": 1346.762,
        "transcript": "Cam im' inerciigalnguum tekiskateng tua-i piningnaqluteng pisciigaciiqnganateng.",
        "translation": "If some rowdy person came upon them, it seemed that they wouldn't have the strength [to apprehend them]."
    },
    "151": {
        "startTime": 1346.767,
        "endTime": 1355.417,
        "transcript": "Inerquutnek makut wani assiitellriit atuqsaileng'erpeciki ayagyuani.",
        "translation": "Young people, it'll be good if you don't do these bad things that are admonished against."
    },
    "152": {
        "startTime": 1356.347,
        "endTime": 1360.237,
        "transcript": "Maligqurassiyaagpek'naki Kass'at makut pisqutait.",
        "translation": "Don't follow what Caucasians tell you to do too much."
    },
    "153": {
        "startTime": 1360.237,
        "endTime": 1368.287,
        "transcript": "Canek tua-i makut puyurtull'e'rnek-llu canek pinglarniitki, iqugglugningqeńilaitki tamakut.",
        "translation": "Also because they say they start marijuana, and that has negative effects."
    },
    "154": {
        "startTime": 1368.287,
        "endTime": 1370.102,
        "transcript": "Tamakut atuqsailengraata.",
        "translation": "Don't abuse those."
    },
    "155": {
        "startTime": 1370.102,
        "endTime": 1373.522,
        "transcript": "Waten tau͡gaam yuuqallerput tang tua-i ikgetlinilria.",
        "translation": "But, you see, our lives are short like this."
    },
    "156": {
        "startTime": 1373.527,
        "endTime": 1383.522,
        "transcript": "Una wani ayagyuallerput, ellangellerput canimelngat'laryaaqell', amta-ll' [?] tua-i waniw' pinialiluta, carpagciigaliluta.",
        "translation": "Our youth and childhood may seem close, yet we become weak, unable to do strenuous things."
    },
    "157": {
        "startTime": 1383.522,
        "endTime": 1390.522,
        "transcript": "Taumek mulngakluci tuaten tamakut assiiterrlainaat maligtevkenaki.",
        "translation": "That's why you should be careful, not only following those bad things."
    },
    "158": {
        "startTime": 1390.527,
        "endTime": 1399.202,
        "transcript": "Cavvliurluci yuungnaqluci akingengnaqluci pikuvci tengruluci quyanarqekacaarciquci.",
        "translation": "We will be very thankful if you do housework, make your own living, and try to earn money enthusiastically."
    },
    "159": {
        "startTime": 1399.202,
        "endTime": 1407.232,
        "transcript": "Akinguteci tau͡gaam tuaten elpeceńun, enevceńun-llu aturluki ikayuutekluki, aklukluki.",
        "translation": "But, use the money you earn for yourselves and your houses to help you, for your things."
    },
    "160": {
        "startTime": 1407.782,
        "endTime": 1417.632,
        "transcript": "Wiinga-ll' tua-i waniwa qitevvneq-llu nalluamku, qaill' ucuryagutekevkenaku atuyuilamku tua-i",
        "translation": "And now, because I don't know how to speak English, don't hold it in high regard since I don't use it"
    },
    "161": {
        "startTime": 1418.422,
        "endTime": 1430.162,
        "transcript": "Pisqeqapigtaqatnga tau͡gaam, ik'um-ll' aiparma maligglua camek, maligglua camek tua-i tegutaqlua, una-kiq qaill' tunllerkaa nalluk'acagaamku.",
        "translation": "Only when they absolutely want me to, and when my spouse across there comes with me, I take something when he comes with me, because I know nothing of how to buy it."
    },
    "162": {
        "startTime": 1430.167,
        "endTime": 1436.427,
        "transcript": "Quyanaqkacagarluni, tua-i quyaaqlua nallucimnek uitanqegcilua uitalaama.",
        "translation": "I'm very thankful, I'm thankful that I don't know because I stay in peace."
    },
    "163": {
        "startTime": 1436.813,
        "endTime": 1444.883,
        "transcript": "Imkut tua-i carrarmek qanlaata tangvak'ngapuk, tayim' amlleriyaaqellilriit-llu qanelpuk.",
        "translation": "Since the ones we watch say little, we've probably spoken enough."
    },
    "164": {
        "startTime": 1445.783,
        "endTime": 1452.983,
        "transcript": "Waten-qaa pitakumegnuk? Amlleriksaitut tayima qanrumallerpuk ava-i.",
        "translation": "Should we stop here? Our long talk hasn't been much."
    },
    "165": {
        "startTime": 1453.558,
        "endTime": 1454.548,
        "transcript": "Tua-i?",
        "translation": "Is that all?"
    },
    "166": {
        "startTime": 1454.548,
        "endTime": 1457.638,
        "transcript": "Tua-i waten pitayugyaaqelrianga.",
        "translation": "I want to stop here."
    },
    "167": {
        "startTime": 1465.588,
        "endTime": 1473.868,
        "transcript": "Qivrunrilkumegnuk piyanrutarpuk tauna ungungssiq tauna nerrleq.",
        "translation": "Had we not been mourning, we wouldn't have [hunted] that animal that was eating."
    },
    "168": {
        "startTime": 1474.153,
        "endTime": 1477.943,
        "transcript": "Kingumek nerluku, nangluku [?].",
        "translation": "We ate it last, finished it [?]."
    },
    "169": {
        "startTime": 1479.333,
        "endTime": 1481.323,
        "transcript": "We eat the meat.",
        "translation": "We eat the meat."
    },
    "170": {
        "startTime": 1482.843,
        "endTime": 1487.683,
        "transcript": "Nerluku-w' tua-i. Wangkuta-llu nerluku tauna nerrleq tauna.",
        "translation": "We ate it. We ate that [animal] that had been eating."
    },
    "171": {
        "startTime": 1487.688,
        "endTime": 1490.408,
        "transcript": "Neqkailamta allamek tua-i nerluku.",
        "translation": "Since we had no other food, we ate it."
    },
    "172": {
        "startTime": 1494.213,
        "endTime": 1498.213,
        "transcript": "Pissuryarat pagkut pagaani ingrini amllertut.",
        "translation": "There are many hunting grounds up in the mountains."
    },
    "173": {
        "startTime": 1499.598,
        "endTime": 1507.798,
        "transcript": "Waniwa ciuqliq: Evsairniik pissuryarauguq.",
        "translation": "Here's the first: Evsairniik is a hunting ground."
    },
    "174": {
        "startTime": 1508.863,
        "endTime": 1517.803,
        "transcript": "Tua-llu tungii: Nacarkarniarmi pissuryaraq mayuumayaraat.",
        "translation": "And next: the hunting grounds at Nacarkiarniar where it takes a long time to climb."
    },
    "175": {
        "startTime": 1518.178,
        "endTime": 1524.508,
        "transcript": "Tua-llu pingayuak: Ilutuqacuk. Wiinga-w' nunautekekeka.",
        "translation": "Then the third: Ilutuqacuk. It's a land under my name."
    },
    "176": {
        "startTime": 1525.778,
        "endTime": 1526.958,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "177": {
        "startTime": 1529.753,
        "endTime": 1534.983,
        "transcript": "Naqerpak-wa, Nurtuucaraq-wa.",
        "translation": "And Naqerpak, and Nurtuucaraq."
    },
    "178": {
        "startTime": 1535.693,
        "endTime": 1538.503,
        "transcript": "Lots of camps [?] upriver.",
        "translation": "Lots of camps [?] upriver."
    },
    "179": {
        "startTime": 1538.503,
        "endTime": 1541.293,
        "transcript": "Qanirtuum-wa Qagatii.",
        "translation": "And Qanirtuum Qagatii."
    },
    "180": {
        "startTime": 1541.293,
        "endTime": 1544.493,
        "transcript": "Way up there [?].",
        "translation": "Way up there [?]."
    },
    "181": {
        "startTime": 1544.498,
        "endTime": 1556.768,
        "transcript": "Nakerpagmek tauna pilaraat wavet Kuinerram Qagatiinun ayagyaraq.",
        "translation": "They call it Nakerpak, the route that goes here to Kuinerram Qagatii."
    },
    "182": {
        "startTime": 1558.188,
        "endTime": 1567.128,
        "transcript": "Kuinerram-llu Qagatiini wani walirnermi nanvam keluani Equgniilngurmi cali pissuryaraq tauna.",
        "translation": "And here on this side of Kuinerram Qagatii, inland from the lake, Equgniilnguq is also a hunting ground."
    },
    "183": {
        "startTime": 1567.413,
        "endTime": 1574.623,
        "transcript": "Una-wa cali iquani igyaraani pissuryaraq cali, nutaan pissuumayaraat.",
        "translation": "And here at the end near the mouth is another hunting ground, a place where they hunt for a long time."
    },
    "184": {
        "startTime": 1574.953,
        "endTime": 1582.033,
        "transcript": "Ukut-llu Kuigglugmiut tuavet uksuarmi ayalartut nangluteng angutet.",
        "translation": "And the people from Kuiggluk go there in the fall until there's no more men."
    },
    "185": {
        "startTime": 1582.418,
        "endTime": 1587.738,
        "transcript": "Tua-i Alussistuaqata'arqata tau͡gaam tekitaqluteng.",
        "translation": "They only return when Christmas is nigh."
    },
    "186": {
        "startTime": 1590.273,
        "endTime": 1599.143,
        "transcript": "Pika-i-ll' pikan Naqailngurmek pilaqiit cali pissuryaraq tauna.",
        "translation": "And up there where they call it Naqailnguq, that's also a hunting ground."
    },
    "187": {
        "startTime": 1600.403,
        "endTime": 1603.043,
        "transcript": "Pissuumayaraat.",
        "translation": "They hunt there for a long time."
    },
    "188": {
        "startTime": 1611.168,
        "endTime": 1616.608,
        "transcript": "Pissuryarat tua-i pagaani tamalkuita nallunritanka.",
        "translation": "I know all of the hunting grounds up there."
    },
    "189": {
        "startTime": 1620.243,
        "endTime": 1627.353,
        "transcript": "Ingriu͡rlurmek aterluni. Ingriu͡rlurmek aterluni ingriq.",
        "translation": "Its name is Ingriu͡rluq. The mountain is called Ingriu͡rluq."
    },
    "190": {
        "startTime": 1627.983,
        "endTime": 1633.453,
        "transcript": "Una-wa uatiini Elngurtuliarmek cali aterluni.",
        "translation": "And downriver from there, it's called Elngurtuliar."
    },
    "191": {
        "startTime": 1633.453,
        "endTime": 1636.693,
        "transcript": "Ukut-wa akiatni Qikertat.",
        "translation": "Across from these are Qikertat."
    },
    "192": {
        "startTime": 1636.988,
        "endTime": 1647.768,
        "transcript": "Ukuk-wa taum Elngurtuliaraam keluani Napanguliignek aterlutek qiurek qulmun napalutek.",
        "translation": "These two inland from Elngurtuliar are called Napanguliik, two boulders standing upright."
    },
    "193": {
        "startTime": 1648.163,
        "endTime": 1654.873,
        "transcript": "Una-wa akiagni Ingrilukaak-gguq.",
        "translation": "On the other side of them, there's what they call Ingrilukaak."
    },
    "194": {
        "startTime": 1654.873,
        "endTime": 1659.153,
        "transcript": "Tua-llu tua-i cali taukuk pissuryaraulutek.",
        "translation": "And so, those are also hunting grounds."
    },
    "195": {
        "startTime": 1659.433,
        "endTime": 1669.353,
        "transcript": "Tauna-llu pikani akiani Iluvaqtuq. Iluvaqtuq-gguq. Cali pissuryarauluni tauna.",
        "translation": "And up there across from that is Iluvaqtuq. They call it Iluvaqtuq. That's also a hunting ground."
    },
    "196": {
        "startTime": 1669.768,
        "endTime": 1675.703,
        "transcript": "Tua-llu kiatiini yaani Ulurrugnaq-gguq.",
        "translation": "Then upriver from there over there, they call it Ulurrugnaq."
    },
    "197": {
        "startTime": 1675.703,
        "endTime": 1683.493,
        "transcript": "Ingriq uverrluni tua-i uverqurluni, uverqurluni ketmun.",
        "translation": "The mountain is slanted, slanted towards the water."
    },
    "198": {
        "startTime": 1684.063,
        "endTime": 1690.093,
        "transcript": "Qukaani-wa can'gurneq una, can'get naumaluteng qagkut.",
        "translation": "In the middle is a grassy plain, the grass growing up there."
    },
    "199": {
        "startTime": 1690.383,
        "endTime": 1698.693,
        "transcript": "Taum-llu qukaani naumalriim tamakut-am ciuqliit qanlartut:",
        "translation": "And in the middle of where they grow, the elders say:"
    },
    "200": {
        "startTime": 1698.793,
        "endTime": 1702.593,
        "transcript": "Tauna-gguq yuk mayullruuq.",
        "translation": "They said that a person climbed."
    },
    "201": {
        "startTime": 1702.818,
        "endTime": 1711.488,
        "transcript": "Tua-i-llu-gguq qukaqerluku aaqilluni tua-i, aciminun-llu uyungluni aaqilluni.",
        "translation": "Then, they said that in the middle, he was nervously wary, and squatted beneath himself out of nervous wariness."
    },
    "202": {
        "startTime": 1712.028,
        "endTime": 1715.268,
        "transcript": "Qaill' pisciiganani, ayagciiganani.",
        "translation": "He couldn't do anything, couldn't go."
    },
    "203": {
        "startTime": 1715.943,
        "endTime": 1722.643,
        "transcript": "Tua-i-gguq pika-i qukaa can'gurnerulartuq ingrim pik'um man'a tekilluku.",
        "translation": "They said that up there, the center of the mountain is a grassy plain to this day."
    },
    "204": {
        "startTime": 1725.228,
        "endTime": 1733.858,
        "transcript": "Tua-ll' kiatiini, kiatiini Atsartuliar-gguq ingricuar angevkenani.",
        "translation": "Then upriver from there, upriver is what they call Atsartulriar, a small mountain that's not big."
    },
    "205": {
        "startTime": 1733.858,
        "endTime": 1736.478,
        "transcript": "Cali pissuumayaraq.",
        "translation": "It's also a long time hunting ground."
    },
    "206": {
        "startTime": 1737.063,
        "endTime": 1748.983,
        "transcript": "Then inland from that small mountain is a small river, a small river going inland with the name Kuignayugpak.",
        "translation": "Then inland from that small mountain is a small river, a small river going inland with the name Kuignayugpak."
    },
    "207": {
        "startTime": 1749.398,
        "endTime": 1754.528,
        "transcript": "Nutaan tauna cali pissuryaraq, pissuumayaraq.",
        "translation": "Now that's a hunting ground, a long time hunting ground."
    },
    "208": {
        "startTime": 1755.348,
        "endTime": 1756.578,
        "transcript": "Tua-llu...",
        "translation": "And then..."
    },
    "209": {
        "startTime": 1757.008,
        "endTime": 1759.843,
        "transcript": "Eskimo name is maanitun mountain.",
        "translation": "[The] Eskimo name is like the mountain here."
    },
    "210": {
        "startTime": 1759.843,
        "endTime": 1763.393,
        "transcript": "Qanirtuum Kuiganun waniw' tekiteqatartua.",
        "translation": "I'm about to reach Qanirtuq River now."
    },
    "211": {
        "startTime": 1764.193,
        "endTime": 1775.023,
        "transcript": "Qanirtuum Kuigan ceńiini... ingriq ima tam' camek pilaqiit?",
        "translation": "On the banks of the Qanirtuq River... what was the mountain called again?"
    },
    "212": {
        "startTime": 1775.693,
        "endTime": 1777.303,
        "transcript": "Ulurrugnaq.",
        "translation": "Ulurrugnaq"
    },
    "213": {
        "startTime": 1777.993,
        "endTime": 1781.473,
        "transcript": "Tauna cali tua-i pissuumayaraq.",
        "translation": "That's also a long time hunting ground."
    },
    "214": {
        "startTime": 1782.818,
        "endTime": 1789.348,
        "transcript": "Tauna-llu kiatiini... cagnek im'? Cayagtuli?",
        "translation": "And upriver from there... what was it again? Cayagtuli?"
    },
    "215": {
        "startTime": 1789.598,
        "endTime": 1790.848,
        "transcript": "Nuu?",
        "translation": "No?"
    },
    "216": {
        "startTime": 1792.878,
        "endTime": 1797.513,
        "transcript": "Nallukenka wiinga. Nanglliut.",
        "translation": "I don't know them. Is that all?"
    },
    "217": {
        "startTime": 1797.513,
        "endTime": 1800.763,
        "transcript": "Nuu, nangeksaitut. Nangyugnaitut.",
        "translation": "No, that's not all. That's far from all."
    },
    "218": {
        "startTime": 1802.4,
        "endTime": 1808.96,
        "transcript": "Tua-ll' pikani Ircaqurrnaq.",
        "translation": "Then up there, Ircaqurrnaq."
    },
    "219": {
        "startTime": 1809.395,
        "endTime": 1813.835,
        "transcript": "Cali pissuryarauguq tauna, Ircaqurrnamek aterluni.",
        "translation": "That's also a hunting ground, with the name Ircaqurrnaq."
    },
    "220": {
        "startTime": 1814.2,
        "endTime": 1822.52,
        "transcript": "Tua-ll' wani ketiini ingricuar ayuqii Ircaqurrnayagarmek atelruni.",
        "translation": "Then here toward the water is a similar mountain with the name Ircaqurrnayagaq."
    },
    "221": {
        "startTime": 1822.535,
        "endTime": 1828.195,
        "transcript": "Tua-ll' yaani kiatiini Evsairrsugaak.",
        "translation": "Then over there upriver from there are Evsairrsugaak."
    },
    "222": {
        "startTime": 1829.86,
        "endTime": 1835.65,
        "transcript": "Cali tamaani pissutuluteng taum yaaqsinrilkiini.",
        "translation": "They also hunt not far from there."
    },
    "223": {
        "startTime": 1838.21,
        "endTime": 1843.03,
        "transcript": "Wani-llu Qerrirtaq.",
        "translation": "And here is Qerrirtaq."
    },
    "224": {
        "startTime": 1843.035,
        "endTime": 1848.265,
        "transcript": "Qerrirtami cali tuani pissuryarauguq. Tang nutaan pissuryarauluni.",
        "translation": "In Qerrirtaq there, it's also a hunting ground. You see, it's a very long standing hunting ground."
    },
    "225": {
        "startTime": 1848.385,
        "endTime": 1853.415,
        "transcript": "Tua-llu piani Cingikeggliq.",
        "translation": "Then inland is Cingikeggliq."
    },
    "226": {
        "startTime": 1854.935,
        "endTime": 1859.895,
        "transcript": "Cingikegglimek aterluni ingriq cingickeggluni qulmun.",
        "translation": "The mountain is named Cingikeggliq with a sharp upward summit."
    },
    "227": {
        "startTime": 1859.96,
        "endTime": 1867.62,
        "transcript": "Tua-ll' ukatiini Kuigglugmun atrarluni ingriq Canirngalriaruuq.",
        "translation": "Then on this side, the mountain going down to Kuiggluk is Canirngalria."
    },
    "228": {
        "startTime": 1868.215,
        "endTime": 1874.525,
        "transcript": "Tua-llu taum akiani Qupun. Quputmek aterluni.",
        "translation": "Then on the other side of that is Qupun. It's named Qupun."
    },
    "229": {
        "startTime": 1875.085,
        "endTime": 1881.655,
        "transcript": "Yaani-w' iquani Canyon-aamek aterluni, Kuignayuggaq cali.",
        "translation": "Over there at the end, it's named Canyon, and Kuignayuggaq."
    },
    "230": {
        "startTime": 1882.675,
        "endTime": 1889.17,
        "transcript": "Wani-llu akiani tauna Nacarkarniarun.",
        "translation": "And here on the other side is Nacarkarniarun."
    },
    "231": {
        "startTime": 1889.17,
        "endTime": 1893.44,
        "transcript": "Nutaan pissuumayaraat mayuumalriit.",
        "translation": "Now that's a long time hunting ground for those who are staying up there."
    },
    "232": {
        "startTime": 1893.82,
        "endTime": 1899.81,
        "transcript": "Tua-ll' cali taum Nacarkarniarutem akiani...",
        "translation": "Then on the other side of Nacarkarniarun..."
    },
    "233": {
        "startTime": 1899.81,
        "endTime": 1901.84,
        "transcript": "Unaten pivkenaku.",
        "translation": "Don't wave your hands."
    },
    "234": {
        "startTime": 1902.94,
        "endTime": 1905.94,
        "transcript": "Evsairniik. Evsairniik-gguq.",
        "translation": "Evsairniik. They call them Evsairniik."
    },
    "235": {
        "startTime": 1906.005,
        "endTime": 1911.135,
        "transcript": "Tua-i cali taukuk pissuumayarak tua-i taukuk ak'anun.",
        "translation": "Those are also a hunting ground for a long time."
    },
    "236": {
        "startTime": 1916.075,
        "endTime": 1917.765,
        "transcript": "He's tired.",
        "translation": "He's tired."
    },
    "237": {
        "startTime": 1917.765,
        "endTime": 1922.555,
        "transcript": "Yeah, so you can take a break, rest, stop for a minute. Yeah, stop.",
        "translation": "Yeah, so you can take a break, rest, stop for a minute. Yeah, stop."
    },
    "238": {
        "startTime": 1922.555,
        "endTime": 1923.695,
        "transcript": "Ii-i, taqsuquten.",
        "translation": "Yes, you're tired."
    },
    "239": {
        "startTime": 1924.03,
        "endTime": 1928.47,
        "transcript": "Au͡gkut-am pissuumayarat tamalkuita qalarutkuraranka.",
        "translation": "I spoke about all of those hunting grounds."
    },
    "240": {
        "startTime": 1928.475,
        "endTime": 1930.625,
        "transcript": "I don't know how to [?] Kass'aq.",
        "translation": "I don't know how to [?] English."
    },
    "241": {
        "startTime": 1933.955,
        "endTime": 1939.655,
        "transcript": "Has he mentioned any stories of big creatures?",
        "translation": "Has he mentioned any stories of big creatures?"
    },
    "242": {
        "startTime": 1939.685,
        "endTime": 1941.475,
        "transcript": "Neqerpangqertuq.",
        "translation": "It has big fish."
    },
    "243": {
        "startTime": 1941.475,
        "endTime": 1943.895,
        "transcript": "Yaa, qanrutkaa ava-i. She already.",
        "translation": "Yes, he just talked about it. She already [did]."
    },
    "244": {
        "startTime": 1943.95,
        "endTime": 1952.75,
        "transcript": "Did he talk about, anything about the skeleton, ribs, skeletons on the beach?",
        "translation": "Did he talk about, anything about the skeleton, ribs, skeletons on the beach?"
    },
    "245": {
        "startTime": 1952.755,
        "endTime": 1954.05,
        "transcript": "It's long time.",
        "translation": "It's [been a] long time."
    },
    "246": {
        "startTime": 1954.05,
        "endTime": 1959.15,
        "transcript": "Yeah, did he talk about that though? (Yaa.) The skeletons on the beach? (Yaa.)",
        "translation": "Yeah, did he talk about that though? (Yes.) The skeletons on the beach? (Yes.)"
    },
    "247": {
        "startTime": 1960.015,
        "endTime": 1968.19,
        "transcript": "[?] the father, her father, long time, the bones, [?back] bones?",
        "translation": "[?] the father, her father, long time, the bones, [?back] bones?"
    },
    "248": {
        "startTime": 1968.19,
        "endTime": 1969.66,
        "transcript": "Yeah, yeah.",
        "translation": "Yeah, yeah."
    },
    "249": {
        "startTime": 1969.66,
        "endTime": 1971.74,
        "transcript": "She get big hole on it.",
        "translation": "She get big hole on it."
    },
    "250": {
        "startTime": 1971.745,
        "endTime": 1972.855,
        "transcript": "Right.",
        "translation": "Right."
    },
    "251": {
        "startTime": 1972.855,
        "endTime": 1975.085,
        "transcript": "In and out, the kids are playing.",
        "translation": "In and out, the kids are playing."
    },
    "252": {
        "startTime": 1975.085,
        "endTime": 1977.34,
        "transcript": "Yeah, that's what I heard.",
        "translation": "Yeah, that's what I heard."
    },
    "253": {
        "startTime": 1977.34,
        "endTime": 1978.35,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "254": {
        "startTime": 1980.58,
        "endTime": 1986.85,
        "transcript": "She's at long grass, that place on ground, place, that old place.",
        "translation": "She's at long grass, that place on ground, place, that old place."
    },
    "255": {
        "startTime": 1986.89,
        "endTime": 1990.88,
        "transcript": "Do you know which side of the lake those were on? North side?",
        "translation": "Do you know which side of the lake those were on? North side?"
    },
    "256": {
        "startTime": 1991.16,
        "endTime": 1994.13,
        "transcript": "No. (South side?) Kuiggluk side.",
        "translation": "No. (South side?) Kwethluk side."
    },
    "257": {
        "startTime": 1994.13,
        "endTime": 1995.6,
        "transcript": "Kuiggluk side of the lake?",
        "translation": "Kwethluk side of the lake?"
    },
    "258": {
        "startTime": 1995.6,
        "endTime": 1997.06,
        "transcript": "That's east side?",
        "translation": "That's east side?"
    },
    "259": {
        "startTime": 1997.065,
        "endTime": 1997.875,
        "transcript": "No.",
        "translation": "No."
    },
    "260": {
        "startTime": 1997.875,
        "endTime": 1998.745,
        "transcript": "South?",
        "translation": "South?"
    },
    "261": {
        "startTime": 1998.745,
        "endTime": 1999.415,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "262": {
        "startTime": 1999.415,
        "endTime": 2001.57,
        "transcript": "Ukatmun caumaluni waten, yaa.",
        "translation": "Facing this way like this, yes."
    },
    "263": {
        "startTime": 2001.57,
        "endTime": 2005.79,
        "transcript": "Kiillaraliin, Heart Lake, Kuiggluk, this side.",
        "translation": "Kiillaraliin, Heart Lake, Kwethluk, this side."
    },
    "264": {
        "startTime": 2005.795,
        "endTime": 2007.925,
        "transcript": "This side, that's where the bones were?",
        "translation": "This side, that's where the bones were?"
    },
    "265": {
        "startTime": 2007.925,
        "endTime": 2008.635,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "266": {
        "startTime": 2009.635,
        "endTime": 2012.505,
        "transcript": "Yaa. Nauw' imna map-an? I'll show you.",
        "translation": "Yes. Where's your map? I'll show you."
    },
    "267": {
        "startTime": 2012.505,
        "endTime": 2013.8,
        "transcript": "Nauw' im' map-an?",
        "translation": "Where's your map?"
    },
    "268": {
        "startTime": 2013.8,
        "endTime": 2018.53,
        "transcript": "Okay, Jerry can you get that? It's back in there, top one.",
        "translation": "Okay, Jerry can you get that? It's back in there, top one."
    },
    "269": {
        "startTime": 2021.58,
        "endTime": 2027.17,
        "transcript": "Tunglirnera map-am Kuiggluum tungiinun imna iciw' waten ayuqelria?",
        "translation": "On the next map, you know how it goes toward Kwethluk like this?"
    },
    "270": {
        "startTime": 2037.8,
        "endTime": 2040.71,
        "transcript": "Right or left? Right?",
        "translation": "Right or left? Right?"
    },
    "271": {
        "startTime": 2041.61,
        "endTime": 2043.66,
        "transcript": "Nauw' im' Kuiggluk?",
        "translation": "Where's Kwethluk?"
    },
    "272": {
        "startTime": 2043.91,
        "endTime": 2045.78,
        "transcript": "Maa-i tang Kuiggluk.",
        "translation": "Look, here's Kwethluk."
    },
    "273": {
        "startTime": 2046.55,
        "endTime": 2048.46,
        "transcript": "Yaa, it's this side.",
        "translation": "Yes, it's this side."
    },
    "274": {
        "startTime": 2050.18,
        "endTime": 2052.54,
        "transcript": "We always stay this side.",
        "translation": "We always stay [on] this side."
    },
    "275": {
        "startTime": 2053.325,
        "endTime": 2055.055,
        "transcript": "Kuikayuk ava-i.",
        "translation": "Kuikayuk is over there."
    },
    "276": {
        "startTime": 2055.065,
        "endTime": 2056.295,
        "transcript": "Can you say this aloud?",
        "translation": "Can you say this aloud?"
    },
    "277": {
        "startTime": 2056.295,
        "endTime": 2057.765,
        "transcript": "Kuikayuk maa-i.",
        "translation": "Here's Kuikayuk."
    },
    "278": {
        "startTime": 2057.765,
        "endTime": 2061.755,
        "transcript": "Ii-i. Crooked Creek Mountain, yaa, waniwa.",
        "translation": "Yes. Crooked Creek Mountain, yes, here it is."
    },
    "279": {
        "startTime": 2071.135,
        "endTime": 2075.465,
        "transcript": "Kiillaraliin-mi nauwa? Maa-i tang.",
        "translation": "Where's Kiillaraliin? Here it is."
    },
    "280": {
        "startTime": 2077.975,
        "endTime": 2081.295,
        "transcript": "(Kiillaraliin ukalirneruuq.) Keligceńaq waniwa.",
        "translation": "(Kiillaraliin is on this side.) Here's Keligceńaq."
    },
    "281": {
        "startTime": 2082.48,
        "endTime": 2086.47,
        "transcript": "Upper Fall-aq, Igceńaq, Qurrlurtaq.",
        "translation": "Upper Fall, Igceńaq, Qurrlurtaq."
    },
    "282": {
        "startTime": 2086.47,
        "endTime": 2087.36,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "283": {
        "startTime": 2087.36,
        "endTime": 2089.35,
        "transcript": "Eskimo name, Qurrlurtaq.",
        "translation": "Eskimo name, Qurrlurtaq."
    },
    "284": {
        "startTime": 2090.37,
        "endTime": 2092.69,
        "transcript": "Taryaqvagtuli waniwa.",
        "translation": "Here's Taryaqvagtuli."
    },
    "285": {
        "startTime": 2097.555,
        "endTime": 2099.07,
        "transcript": "[?] wani.",
        "translation": "[?] here."
    },
    "286": {
        "startTime": 2099.07,
        "endTime": 2104.37,
        "transcript": "Kana-i walirnerani. Walirnera'antuq.",
        "translation": "Down there on this side. It's on this side."
    },
    "287": {
        "startTime": 2104.375,
        "endTime": 2106.77,
        "transcript": "Ukalirnera'antuq tuani.",
        "translation": "It's on this side there."
    },
    "288": {
        "startTime": 2106.77,
        "endTime": 2109.41,
        "transcript": "[?]",
        "translation": "[?]"
    },
    "289": {
        "startTime": 2109.415,
        "endTime": 2112.915,
        "transcript": "Evon Qugg'aq [?].",
        "translation": "Evon Qugg'aq [?]."
    },
    "290": {
        "startTime": 2116.3,
        "endTime": 2118.19,
        "transcript": "You know stories, or?",
        "translation": "You know stories, or?"
    },
    "291": {
        "startTime": 2119.96,
        "endTime": 2123.84,
        "transcript": "No, it's older than [?].",
        "translation": "No, it's older than [?]."
    },
    "292": {
        "startTime": 2125.015,
        "endTime": 2133.315,
        "transcript": "She's teaching for hunting, walking. No stove, just tent in winter.",
        "translation": "She's teaching for hunting, walking. No stove, just tent in winter."
    },
    "293": {
        "startTime": 2136.21,
        "endTime": 2139.35,
        "transcript": "When you went to Heart Lake, did you walk?",
        "translation": "When you went to Heart Lake, did you walk?"
    },
    "294": {
        "startTime": 2139.355,
        "endTime": 2141.67,
        "transcript": "Nuu, by plane.",
        "translation": "No, by plane."
    },
    "295": {
        "startTime": 2141.67,
        "endTime": 2146.61,
        "transcript": "This time? Long time ago, though, you walked?",
        "translation": "This time? Long time ago, though, you walked?"
    },
    "296": {
        "startTime": 2146.615,
        "endTime": 2147.37,
        "transcript": "Dogs.",
        "translation": "Dogs."
    },
    "297": {
        "startTime": 2147.37,
        "endTime": 2148.27,
        "transcript": "Dogs.",
        "translation": "Dogs."
    },
    "298": {
        "startTime": 2148.945,
        "endTime": 2150.205,
        "transcript": "Dog team.",
        "translation": "Dog team."
    },
    "299": {
        "startTime": 2151.2,
        "endTime": 2153.04,
        "transcript": "So you went to Heart Lake in the winter?",
        "translation": "Do you went to Heart Lake in the winter?"
    },
    "300": {
        "startTime": 2153.995,
        "endTime": 2158.215,
        "transcript": "Spring. (In the spring toward the fall?) Beaver hunting that time.",
        "translation": "Spring. (In the spring toward the fall?) Beaver hunting that time."
    },
    "301": {
        "startTime": 2162.22,
        "endTime": 2167.43,
        "transcript": "Now is, fall-ami tau͡gaam this year.",
        "translation": "Now is, it was in the fall instead this year."
    },
    "302": {
        "startTime": 2167.43,
        "endTime": 2172.72,
        "transcript": "How many years, since long time. Her daughter went up too.",
        "translation": "How many years, since long time. Her daughter went up too."
    },
    "303": {
        "startTime": 2173.39,
        "endTime": 2177.12,
        "transcript": "I didn't go up because I'm sickly.",
        "translation": "I didn't go up because I'm sickly."
    },
    "304": {
        "startTime": 2178.67,
        "endTime": 2180.49,
        "transcript": "They flew up this year?",
        "translation": "They flew up this year?"
    },
    "305": {
        "startTime": 2181.615,
        "endTime": 2183.575,
        "transcript": "Old-angua.",
        "translation": "I'm getting old."
    },
    "306": {
        "startTime": 2188.53,
        "endTime": 2195.94,
        "transcript": "Is the lake, the lake's good now? There's no big fish in the lake? It's good? No...",
        "translation": "Is the lake, the lake's good now? There's no big fish in the lake? It's good? No..."
    },
    "307": {
        "startTime": 2196.69,
        "endTime": 2202.43,
        "transcript": "She got lots of talaarit. [?] Caulriit ima talaarit?",
        "translation": "She got lots of talaarit [rainbow trout]. [?] What are talaarit again?"
    },
    "308": {
        "startTime": 2207.345,
        "endTime": 2210.215,
        "transcript": "Canek ima tam' pilaqait fish-at?",
        "translation": "What do they call those fish again?"
    },
    "309": {
        "startTime": 2211.06,
        "endTime": 2215.65,
        "transcript": "(Kina?) Talaarit. (Kina?) Trout-at-wa nanvani.",
        "translation": "(Who?) Talaarit. (Who?) Trout in the lakes."
    },
    "310": {
        "startTime": 2217.18,
        "endTime": 2219.04,
        "transcript": "Cikignat.",
        "translation": "Lake trout."
    },
    "311": {
        "startTime": 2219.045,
        "endTime": 2221.455,
        "transcript": "Small ones. (Yaa.) We're fishing. (Yaa.)",
        "translation": "Small ones. (Yes.) We're fishing. (Yes.)"
    },
    "312": {
        "startTime": 2221.455,
        "endTime": 2222.525,
        "transcript": "Cikignat.",
        "translation": "Lake trout."
    },
    "313": {
        "startTime": 2222.525,
        "endTime": 2224.895,
        "transcript": "[?] small one.",
        "translation": "[?] small one."
    },
    "314": {
        "startTime": 2224.895,
        "endTime": 2227.805,
        "transcript": "But no creatures in there, like, no stories anymore?",
        "translation": "But no creatures in there, like, no stories anymore?"
    },
    "315": {
        "startTime": 2227.805,
        "endTime": 2233.665,
        "transcript": "Sometime, her youngest brother... but we're from mountainside.",
        "translation": "Sometime, her youngest brother... but we're from mountainside."
    },
    "316": {
        "startTime": 2233.85,
        "endTime": 2238.08,
        "transcript": "He saw the something bubbling the water.",
        "translation": "He saw the something bubbling the water."
    },
    "317": {
        "startTime": 2238.6,
        "endTime": 2242.63,
        "transcript": "And then he saw lots of spots.",
        "translation": "And then he saw lots of spots."
    },
    "318": {
        "startTime": 2243.01,
        "endTime": 2249.21,
        "transcript": "Down, way down, it's clear. You know the clear water?",
        "translation": "Down, way down, it's clear. You know the clear water?"
    },
    "319": {
        "startTime": 2249.215,
        "endTime": 2250.39,
        "transcript": "Clear water?",
        "translation": "Clear water?"
    },
    "320": {
        "startTime": 2250.39,
        "endTime": 2255.29,
        "transcript": "Yes, way down there, he saw the spots, [?black].",
        "translation": "Yes, way down there, he saw the spots, [?black]."
    },
    "321": {
        "startTime": 2255.295,
        "endTime": 2256.435,
        "transcript": "When was that?",
        "translation": "When was that?"
    },
    "322": {
        "startTime": 2256.64,
        "endTime": 2259.6,
        "transcript": "Almost jump up.",
        "translation": "Almost jump up."
    },
    "323": {
        "startTime": 2259.755,
        "endTime": 2261.265,
        "transcript": "This time? This trip?",
        "translation": "This time? This trip?"
    },
    "324": {
        "startTime": 2261.265,
        "endTime": 2262.475,
        "transcript": "Nuu, long time.",
        "translation": "No, long time."
    },
    "325": {
        "startTime": 2262.475,
        "endTime": 2263.15,
        "transcript": "Oh, long time?",
        "translation": "Oh, long time?"
    },
    "326": {
        "startTime": 2263.15,
        "endTime": 2270.09,
        "transcript": "Her brother, when she was like... she's in hospital now.",
        "translation": "Her brother, when she was like... she's in hospital now."
    },
    "327": {
        "startTime": 2271.805,
        "endTime": 2275.875,
        "transcript": "So, did people get scared and stop going there, or people always went there?",
        "translation": "So, did people get scared and stop going there, or people always went there?"
    },
    "328": {
        "startTime": 2276.225,
        "endTime": 2280.075,
        "transcript": "But me, I'm scared I might eat airplane.",
        "translation": "But me, I'm scared I might eat airplane."
    },
    "329": {
        "startTime": 2285.285,
        "endTime": 2289.965,
        "transcript": "Really, I'm scared we might eat.",
        "translation": "Really, I'm scared we might eat."
    },
    "330": {
        "startTime": 2290.94,
        "endTime": 2302.85,
        "transcript": "You ever, you or Wassilie ever hear of a stone face on top of a mountain by Kiseralik?",
        "translation": "You ever, you or Wassilie ever hear of a stone face on top of a mountain by Kiseralik?"
    },
    "331": {
        "startTime": 2303.16,
        "endTime": 2305.26,
        "transcript": "Stone head, face?",
        "translation": "Stone head, face?"
    },
    "332": {
        "startTime": 2305.555,
        "endTime": 2308.25,
        "transcript": "No, I never go Kiillaraliin.",
        "translation": "No, I never go Kiillaraliin."
    },
    "333": {
        "startTime": 2308.25,
        "endTime": 2315.5,
        "transcript": "Can you ask him? A stone head by Kiseralik, does he know? Can you ask?",
        "translation": "Can you ask him? A stone head by Kiseralik, does he know? Can you ask?"
    },
    "334": {
        "startTime": 2315.83,
        "endTime": 2316.98,
        "transcript": "What head?",
        "translation": "What head?"
    },
    "335": {
        "startTime": 2316.98,
        "endTime": 2320.26,
        "transcript": "Stone, rock, on top of a mountain.",
        "translation": "Stone, rock, on top of a mountain."
    },
    "336": {
        "startTime": 2320.265,
        "endTime": 2323.375,
        "transcript": "You never heard, huh? (I don't know. Nalluaqa.)",
        "translation": "You never heard, huh? (I don't know. I don't know it.)"
    },
    "337": {
        "startTime": 2324.095,
        "endTime": 2328.875,
        "transcript": "Did you know a Old Man Reed that a mine up on the Kiseralik?",
        "translation": "Did you know a Old Man Reed that a mine up on the Kiseralik?"
    },
    "338": {
        "startTime": 2329.38,
        "endTime": 2330.38,
        "transcript": "Nuu.",
        "translation": "No."
    },
    "339": {
        "startTime": 2330.385,
        "endTime": 2334.0,
        "transcript": "I always went up [?], always [?] 'cause I would...",
        "translation": "I always went up [?], always [?] 'cause I would..."
    },
    "340": {
        "startTime": 2334.0,
        "endTime": 2335.42,
        "transcript": "Only went up to...",
        "translation": "Only went up to..."
    },
    "341": {
        "startTime": 2335.425,
        "endTime": 2336.985,
        "transcript": "'Cause I would, yeah.",
        "translation": "'Cause I would, yeah."
    },
    "342": {
        "startTime": 2336.987,
        "endTime": 2341.657,
        "transcript": "One time, he went up to Kiillaraliin, but always raining.",
        "translation": "One time, he went up to Kiillaraliin, but always raining."
    },
    "343": {
        "startTime": 2342.697,
        "endTime": 2348.217,
        "transcript": "Summer stories we've had, the people go up to Kiseralik all the time, but they were afraid to go to Heart Lake",
        "translation": "Summer stories we've had, the people go up to Kiseralik all the time, but they were afraid to go to Heart Lake"
    },
    "344": {
        "startTime": 2348.742,
        "endTime": 2354.412,
        "transcript": "'Cause there's supposed to be a creature over there, so they never did go to Kiseralik, I mean, to Heart Lake.",
        "translation": "'Cause there's supposed to be a creature over there, so they never did go to Kiseralik, I mean, to Heart Lake."
    },
    "345": {
        "startTime": 2354.412,
        "endTime": 2358.062,
        "transcript": "We talked to Fanny, Fanny.",
        "translation": "We talked to Fanny, Fanny."
    },
    "346": {
        "startTime": 2358.062,
        "endTime": 2359.612,
        "transcript": "Yaa. (Yaa.)",
        "translation": "Yes. (Yes.)"
    },
    "347": {
        "startTime": 2359.612,
        "endTime": 2369.932,
        "transcript": "When she was young, her brother, David Jackson, long time, she went up that way.",
        "translation": "When she was young, her brother, David Jackson, long time, she went up that way."
    },
    "348": {
        "startTime": 2371.157,
        "endTime": 2374.457,
        "transcript": "Atam, I'll show you Kiillaraliin Lake.",
        "translation": "Look, I'll show you Kiillaraliin Lake."
    },
    "349": {
        "startTime": 2385.802,
        "endTime": 2386.662,
        "transcript": "Nani?",
        "translation": "Where?"
    },
    "350": {
        "startTime": 2386.667,
        "endTime": 2387.777,
        "transcript": "Mamterillermi.",
        "translation": "In Bethel."
    },
    "351": {
        "startTime": 2388.527,
        "endTime": 2390.322,
        "transcript": "Niitellruanka icivaq.",
        "translation": "I heard about them recently."
    },
    "352": {
        "startTime": 2390.322,
        "endTime": 2393.342,
        "transcript": "(Uungiciingartenrilkenka tang.) Yaa, uunguciitanka wii.",
        "translation": "(I don't understand them, you see.) Yes, I don't understand them."
    },
    "353": {
        "startTime": 2393.347,
        "endTime": 2394.487,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "354": {
        "startTime": 2398.082,
        "endTime": 2400.632,
        "transcript": "Roll-angllilriakuk waniwa.",
        "translation": "We've probably started rolling now."
    },
    "355": {
        "startTime": 2404.402,
        "endTime": 2405.382,
        "transcript": "Wait.",
        "translation": "Wait."
    },
    "356": {
        "startTime": 2406.627,
        "endTime": 2417.382,
        "transcript": "William, kitek' nani yuurtellerpenek, maa-i-llu qavcinek allrakungellerpenek qanruarteqerkut.",
        "translation": "William, please quickly say where you were born, and how old you are now."
    },
    "357": {
        "startTime": 2417.382,
        "endTime": 2423.552,
        "transcript": "Yaa, maa-i wani 1915-aami yuurtellruunga ak'a",
        "translation": "Okay, I was born in 1915 long ago"
    },
    "358": {
        "startTime": 2423.782,
        "endTime": 2431.532,
        "transcript": "Man'a wani Kusquqviim ilua nepaunaku, yuut-llu wani waten cav'urluteng.",
        "translation": "When the Kuskokwim here was peaceful, and people traveled by rowing."
    },
    "359": {
        "startTime": 2431.822,
        "endTime": 2435.732,
        "transcript": "Cav'urluteng-llu neqsurluteng. Levaartaunani.",
        "translation": "And they'd row to go fishing. There were no boat motors."
    },
    "360": {
        "startTime": 2436.492,
        "endTime": 2442.172,
        "transcript": "Maa-i wani qavcinek allrakungsit umyuaqellerpeni, nallunritlerpeni?",
        "translation": "How old are you now as you remember it, as you know it?"
    },
    "361": {
        "startTime": 2442.177,
        "endTime": 2444.767,
        "transcript": "Seventy-five-aaryugnarqua.",
        "translation": "I think I'm 75."
    },
    "362": {
        "startTime": 2446.387,
        "endTime": 2448.657,
        "transcript": "Yugtun-llu cali atren qanrutekluku.",
        "translation": "Also say your name in Yup'ik."
    },
    "363": {
        "startTime": 2448.657,
        "endTime": 2449.952,
        "transcript": "Callerkuaq.",
        "translation": "Callerkuaq."
    },
    "364": {
        "startTime": 2449.952,
        "endTime": 2451.552,
        "transcript": "Callerkuaq? (Yaa.)",
        "translation": "Callerkuaq? (Yes.)"
    },
    "365": {
        "startTime": 2451.567,
        "endTime": 2452.467,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "366": {
        "startTime": 2453.542,
        "endTime": 2462.522,
        "transcript": "Ayagyuallerpeni qaillun caliaqerraallerpenek cali qanruarteqerkut.",
        "translation": "Also, please tell us about your first job when you were young."
    },
    "367": {
        "startTime": 2463.207,
        "endTime": 2469.637,
        "transcript": "Agayuvigmi Elders-aarullruunga. Agayuvigmi qallatesteńguaqlua.",
        "translation": "I was part of the Elders of the church. I was a preacher in church."
    },
    "368": {
        "startTime": 2470.057,
        "endTime": 2476.197,
        "transcript": "Ayagyuanun-llu, imkunun Young People leader-aarulua.",
        "translation": "And to the young people, I was a leader for the Young People."
    },
    "369": {
        "startTime": 2477.092,
        "endTime": 2486.892,
        "transcript": "Kinguakun-llu council-aanun eklua, IRA Council, tamaani '43-aam nuniini.",
        "translation": "And after that, I went into the could, IRA Council, back around '43."
    },
    "370": {
        "startTime": 2487.797,
        "endTime": 2493.817,
        "transcript": "Tamaaken-ll' ayaglua una council-aani alerquuciulqa taqsuunani.",
        "translation": "And from then on, I never stopped working with the tribal council regulations."
    },
    "371": {
        "startTime": 2494.082,
        "endTime": 2504.782,
        "transcript": "Mat'umi-llu Yup'imteńi wangkuta yuullemteńi nutaan alerquun tamana cali nalluvkenaku.",
        "translation": "And as we Yupiit live here, I especially know that traditional instruction too."
    },
    "372": {
        "startTime": 2505.467,
        "endTime": 2510.007,
        "transcript": "Ukut-llu cali.. elitnauraullrunritua.",
        "translation": "And these too... I wasn't a student."
    },
    "373": {
        "startTime": 2510.562,
        "endTime": 2519.792,
        "transcript": "Anguyagtem cali federal-aam Territory of Alaska, taum cali alerquutai murilkelluki.",
        "translation": "And the federal government, the Territory of Alaska, I also observed its laws."
    },
    "374": {
        "startTime": 2520.702,
        "endTime": 2529.422,
        "transcript": "Elitnauraqlua-ll' imkunek, alerquutnek elisngalrianek tangvagluki tamakunek.",
        "translation": "And I would study those by watching those who knew the laws."
    },
    "375": {
        "startTime": 2531.507,
        "endTime": 2539.817,
        "transcript": "Maa-i wani ernerpak man'a wani Yugni wangkuta arenqiallugutvut taangaq",
        "translation": "These days, about the problem of us Yupiit, alcohol"
    },
    "376": {
        "startTime": 2541.627,
        "endTime": 2549.762,
        "transcript": "Qaillun imumi ayuqucillra, maa-i cali Mamterillermi wall'u nunani ayuqsaaquq umgumaluni.",
        "translation": "What it was like back then, it's still closed now in Bethel or in villages."
    },
    "377": {
        "startTime": 2549.762,
        "endTime": 2555.632,
        "transcript": "Kitak' qanrutkeqerru qaillun ayuqellra, maa-i-llu cangallrullra.",
        "translation": "Please talk about what it was like, and how it's different today."
    },
    "378": {
        "startTime": 2555.632,
        "endTime": 2562.842,
        "transcript": "Nineteen-thirty merkun waten akacakarraalriamek niitellruunga.",
        "translation": "In 1930, I first heard about someone having an accident in the water."
    },
    "379": {
        "startTime": 2563.892,
        "endTime": 2567.632,
        "transcript": "Tangerrluku-llu mat'um taangam piluku.",
        "translation": "And I saw that alcohol had gotten him."
    },
    "380": {
        "startTime": 2567.937,
        "endTime": 2575.127,
        "transcript": "Tua-i-ll' kinguakun niitellruunga cali taangakun ellminek nutellriamek.",
        "translation": "Then after that, I also heard about someone who shot himself under the influence of alcohol."
    },
    "381": {
        "startTime": 2575.667,
        "endTime": 2580.082,
        "transcript": "Akultuluni. Allrakuni pingatuq.",
        "translation": "It was long after. I think it was a year after."
    },
    "382": {
        "startTime": 2580.082,
        "endTime": 2591.932,
        "transcript": "Cali taum kinguani akulturaqerluku yugmek cali niitellrulua up'nerkami cupellrani catailngurmek.",
        "translation": "Also, for a long time after that, I also heard about a person who was missing in the spring when the ice broke up."
    },
    "383": {
        "startTime": 2591.932,
        "endTime": 2598.582,
        "transcript": "Kiagumainanrani-ll' nataqngatgu cakmavet anelrarluta paqnayugluta.",
        "translation": "And when they found him in the summer, we went downriver to go see him."
    },
    "384": {
        "startTime": 2598.742,
        "endTime": 2602.442,
        "transcript": "Tua-i taum taangam piqarraallrek.",
        "translation": "Those were the first victims of alcohol."
    },
    "385": {
        "startTime": 2602.787,
        "endTime": 2608.222,
        "transcript": "Tua-ll' maaken ayagluni ukaqvanek pinerturiuq.",
        "translation": "Then from here on out to now, it happens a lot."
    },
    "386": {
        "startTime": 2608.222,
        "endTime": 2611.822,
        "transcript": "Cukaqapiggluteng tua-i makut tan'gaurluut.",
        "translation": "These boys are [dying] at a very fast rate."
    },
    "387": {
        "startTime": 2613.047,
        "endTime": 2617.997,
        "transcript": "Ikingqallrani-ll' tua-i nutaan kanvelriatun ayuqellruluteng.",
        "translation": "And when it was open, it really was like they were dropping rapidly."
    },
    "388": {
        "startTime": 2618.797,
        "endTime": 2625.687,
        "transcript": "Maa-i-ll' nutaan, mat'umi ernemteńi nutaan assiitqapiarluni.",
        "translation": "Especially now, it's especially awful in our current day."
    },
    "389": {
        "startTime": 2626.907,
        "endTime": 2637.577,
        "transcript": "Wiinga alingniurlua iliini qavalartua makut wani ayagyuat arenqialata.",
        "translation": "Sometimes, I sleep in fear because these young people are distressing."
    },
    "390": {
        "startTime": 2640.667,
        "endTime": 2651.457,
        "transcript": "Qaillun wani alerquayugngasikut tamatum tungiinun, qaillun-llu ikayuucugngallemteńek tamatumek naulluutelegmek?",
        "translation": "What can you instruct us about that, and how we can help someone with that addiction?"
    },
    "391": {
        "startTime": 2652.057,
        "endTime": 2659.227,
        "transcript": "Makut wani arenqiallugutellget, naulluutellget, man'a-gguq tau͡gaam ciumek: kenka.",
        "translation": "For those with that problem, addiction, they say this is the first: love."
    },
    "392": {
        "startTime": 2660.417,
        "endTime": 2665.712,
        "transcript": "Cali-ll' tua-i angtuamek atungraata nangrurpek'naki.",
        "translation": "And even if they heavily abuse it, don't condemn them."
    },
    "393": {
        "startTime": 2665.712,
        "endTime": 2674.222,
        "transcript": "Tau͡gaam cakanirpek'naku waten nutemllarmi yuuyaramteńi kenka, au͡gkut ciuliamta piciryaraatni.",
        "translation": "Instead, treat them no different with the love of our ancient way of life, our ancestors' tradition."
    },
    "394": {
        "startTime": 2674.962,
        "endTime": 2679.512,
        "transcript": "Tamana tua-i perriq'apiarluku yuusciigatliniukut.",
        "translation": "It turns out, we can't completely eradicate that as we live."
    },
    "395": {
        "startTime": 2681.292,
        "endTime": 2685.822,
        "transcript": "Ilait wani ilaliunritnayukluteng pilartut.",
        "translation": "Some think that people won't socialize with them."
    },
    "396": {
        "startTime": 2686.412,
        "endTime": 2695.412,
        "transcript": "Cali waten qalarutarkauluki unguvallerkaita pianek, qalaruyutiinek.",
        "translation": "We must also talk to them like this about their lives', you know, traditional wisdom."
    },
    "397": {
        "startTime": 2696.927,
        "endTime": 2707.502,
        "transcript": "Maa-i, maa-i wani una wani naulluutelek waten qanraqan: \"Tua-i tang wii taqsugyaaqellrianga. Wiinga meryuumiirucaaqua,\"",
        "translation": "Now, when someone with an addiction says this: \"I want to quit. I don't want to drink anymore,\""
    },
    "398": {
        "startTime": 2707.502,
        "endTime": 2713.572,
        "transcript": "Ilaitni waten kiularaput: \"Tua-i-w' inerqularyaaqekemken. Niicunrit'lalriaten.\"",
        "translation": "Some of us answer them like this: \"I do admonish you. You don't listen.\""
    },
    "399": {
        "startTime": 2713.572,
        "endTime": 2721.882,
        "transcript": "Qaillun elpet tamana, alerqeryugngaceta qaillun kiulallerkamteńek tauna tuaten piyugteqellria?",
        "translation": "How would you, how would you instruct us to answer that person who is eager [to quit] like that?"
    },
    "400": {
        "startTime": 2722.852,
        "endTime": 2729.242,
        "transcript": "Tauna tuaten piyugteqellria qanelqa tua-i ukveqluku pinarqellriaruuq.",
        "translation": "One who is eager [to quit] like that must believe what I said."
    },
    "401": {
        "startTime": 2731.062,
        "endTime": 2738.722,
        "transcript": "Cat ilaitni tanglartua tamana taqsaraq piciuluku akurturluku.",
        "translation": "Sometimes, I see someone who truly does end up quitting."
    },
    "402": {
        "startTime": 2740.627,
        "endTime": 2746.877,
        "transcript": "Tau͡gaam maa-i ilait wani taqesciigatut.",
        "translation": "But now, some can't quit."
    },
    "403": {
        "startTime": 2746.907,
        "endTime": 2757.107,
        "transcript": "Mat'umek alcohol-aamek tribal court-akun caliangqertua. Iliini nine-aarulartut tan'gaurluut.",
        "translation": "I work with alcohol [addiction] through the tribal court. Sometimes, there are nine boys."
    },
    "404": {
        "startTime": 2758.032,
        "endTime": 2762.072,
        "transcript": "Tau͡gaam wangkut court-amteggun caliaqluki.",
        "translation": "But we work with them through our court."
    },
    "405": {
        "startTime": 2762.787,
        "endTime": 2765.797,
        "transcript": "Assiqapiarluni. Assikluku wii.",
        "translation": "It's very good. l like it."
    },
    "406": {
        "startTime": 2766.767,
        "endTime": 2772.702,
        "transcript": "Tau͡gaam imkut cali elitnaurayagaat waten angtalriit",
        "translation": "But also, those small students who are this big"
    },
    "407": {
        "startTime": 2772.702,
        "endTime": 2782.512,
        "transcript": "Quyuita tuavet itrucugngaanka camek akeqnerrlugmek pivkenaki, qalarulluki tau͡gaam au͡gkut ciuliamta piciryaraicetun.",
        "translation": "I can bring them in together there without any sentence, but talk to them as was our ancestors' custom."
    },
    "408": {
        "startTime": 2782.652,
        "endTime": 2787.482,
        "transcript": "Ukut tau͡gken angtuaq imna 20 years, 20 years-alria",
        "translation": "But these, an older one at 20 years, who's 20 years old"
    },
    "409": {
        "startTime": 2787.772,
        "endTime": 2796.982,
        "transcript": "Tauna au͡gkutun mikelngurtun caliaqnarqenrituq wangni tuani Yugtarmi qanercetaarvimteńi.",
        "translation": "To me, I cannot work with him as those children there in our Yup'ik court."
    },
    "410": {
        "startTime": 2798.132,
        "endTime": 2806.662,
        "transcript": "Tau͡gaam pinarqellria tuaken cakmavet uitasngaunaku aaryugluta pikumta.",
        "translation": "But we will not ignore one who needs that, but bring them downriver if we're wary."
    },
    "411": {
        "startTime": 2807.782,
        "endTime": 2814.932,
        "transcript": "Maa-i man'a nallunritelqa atulqa-llu qanruteksugngaaqa.",
        "translation": "Now, I can speak about what I know and what I've experienced."
    },
    "412": {
        "startTime": 2816.092,
        "endTime": 2825.102,
        "transcript": "Ava-i qanertuten wani makut mikelnguut wall'u ayagyuat au͡gkunek qanruyutnek niitelallerpenek qanrut'larniluki.",
        "translation": "You just said that you tell the children or young people about the traditional wisdom that you used to hear."
    },
    "413": {
        "startTime": 2825.102,
        "endTime": 2830.192,
        "transcript": "Kitak' qanruyutnek tamakunek niitelallerpenek taiqaniiriqaa.",
        "translation": "Please bring forth that traditional wisdom you used to hear."
    },
    "414": {
        "startTime": 2830.192,
        "endTime": 2840.602,
        "transcript": "Waten, waten ayuquq: \"Qetunramaa, niiskiu aatan aanan-llu. Niisngakek unguvanaurtuten.\"",
        "translation": "This, this is what it's like: \"My son, obey your father and mother. Obey them, so that you will live.\""
    },
    "415": {
        "startTime": 2841.192,
        "endTime": 2846.802,
        "transcript": "Tamaa-i tamana au͡gkunun angenrilngurnun qanruyun.",
        "translation": "That's traditional wisdom for those [children] who aren't big."
    },
    "416": {
        "startTime": 2847.692,
        "endTime": 2857.972,
        "transcript": "Cali waten qanrulluku: inarcaraq tekiskan cass'aq camek niiskata egmian utertesqelluki.",
        "translation": "Also tell them this: when the time to go to bed has come for them to go home right away."
    },
    "417": {
        "startTime": 2858.557,
        "endTime": 2864.707,
        "transcript": "Una-gguq wani unuum qukallran kingua wangkuta yuuyaramteńi",
        "translation": "They say that after midnight, in our way of life"
    },
    "418": {
        "startTime": 2865.067,
        "endTime": 2872.097,
        "transcript": "Unuum-gguq qukallran kinguani elliraqami avtetuuq yuk.",
        "translation": "They say that after midnight, a person's behavior splits."
    },
    "419": {
        "startTime": 2873.647,
        "endTime": 2879.097,
        "transcript": "Caarkaurrluni tua-i umyugaa qamna, enemun itrarkaurrluni.",
        "translation": "Their mind will get an idea, [s]he will go into a house."
    },
    "420": {
        "startTime": 2880.197,
        "endTime": 2884.807,
        "transcript": "Caarkaiturarkaurrluni unuum qukallran kinguani.",
        "translation": "[S]he will have nothing [but mischief] to do after midnight."
    },
    "421": {
        "startTime": 2884.807,
        "endTime": 2890.347,
        "transcript": "Tamaa-i tamakut au͡gkut ciuliamta tamana cali qanrutkellrat.",
        "translation": "That's something that our ancestors also spoke of."
    },
    "422": {
        "startTime": 2892.342,
        "endTime": 2898.362,
        "transcript": "Camek cali arcaqalriamek elpet qaneryullerpenek",
        "translation": "Any other important thing that you want to say"
    },
    "423": {
        "startTime": 2898.367,
        "endTime": 2908.757,
        "transcript": "Alerquutngulliuq, inerquutngulliuq, wall'u tua-i wangkuta piciryaramteńek Yup'igni avani ciuqvallaat piciryaraat.",
        "translation": "It may be traditional instruction, an admonishment, or from our Yup'ik culture, the culture of [our] people long ago."
    },
    "424": {
        "startTime": 2908.957,
        "endTime": 2913.337,
        "transcript": "Waniw' cali qanrutkeqerru. Qaneryullerpenek qanra.",
        "translation": "Please speak about it now. Say what you want."
    },
    "425": {
        "startTime": 2913.892,
        "endTime": 2923.252,
        "transcript": "Avani ciuliamta piciryaraitni camek pitaitellruuq, tau͡gaam qasgimek.",
        "translation": "Back in our ancestors' culture, there was nothing except for the community house."
    },
    "426": {
        "startTime": 2924.187,
        "endTime": 2928.167,
        "transcript": "Tuani qasgimi qalarut'lallruitkut.",
        "translation": "They would instruct us there in the community house."
    },
    "427": {
        "startTime": 2928.182,
        "endTime": 2934.882,
        "transcript": "Tau͡gaam cali enemun itraqama uavet nangertetullruunga.",
        "translation": "But also, when I'd go into a house, I'd stand back at the door."
    },
    "428": {
        "startTime": 2935.467,
        "endTime": 2943.557,
        "transcript": "Qanelriartangqelartuq maaken, \"Ugyuurluuq,\" tua-i piu͡rlurmek pilua.",
        "translation": "Someone from here would say, \"Dear one back there,\" calling me by an endearing term."
    },
    "429": {
        "startTime": 2943.987,
        "endTime": 2951.357,
        "transcript": "Uaken-llu tua-i teguyaramek natetmun amllirciiganata anqertesciiganata-llu.",
        "translation": "And from the handle at the exit, we couldn't step anywhere or run out."
    },
    "430": {
        "startTime": 2952.247,
        "endTime": 2958.217,
        "transcript": "Maa-i wani qalarucilriamek angukengnanrirtua.",
        "translation": "Now, I don't come across anyone giving instruction anymore."
    },
    "431": {
        "startTime": 2958.927,
        "endTime": 2965.487,
        "transcript": "Waniwa watua ernemteńi angukengnanrirtua tamatumek.",
        "translation": "In our current day, I don't come across that anymore."
    },
    "432": {
        "startTime": 2966.937,
        "endTime": 2969.237,
        "transcript": "Ciin tamana tuaten piuga?",
        "translation": "Why is that the case?"
    },
    "433": {
        "startTime": 2970.172,
        "endTime": 2973.702,
        "transcript": "Nutem piulliniuq ak'a tamaaken ayagluni.",
        "translation": "It's an ancient traditional from long ago."
    },
    "434": {
        "startTime": 2973.802,
        "endTime": 2978.452,
        "transcript": "Waten alerquutet makut Yupiim wangkuk alerquutepuk",
        "translation": "Like this, our traditional Yup'ik instructions"
    },
    "435": {
        "startTime": 2978.762,
        "endTime": 2988.952,
        "transcript": "Yuinaat qulen allrakut cipluki cimiyuitelliniuq, nepliyuunani.",
        "translation": "Even over a hundred years, it doesn't change, and doesn't sow discord."
    },
    "436": {
        "startTime": 2988.952,
        "endTime": 2996.052,
        "transcript": "Nepaitnamek tau͡gaam qaneryugngaluni, nepaitnamek yuk inerquryugngaluku.",
        "translation": "Instead, you can speak of peace, you can admonish a person to be peaceful."
    },
    "437": {
        "startTime": 2997.112,
        "endTime": 3007.282,
        "transcript": "Cali waten nunat, nunarraat angayuqangqetullrulliniluteng tegganermek ataucimek ayuqucirturteḿek.",
        "translation": "Also, villages like this, small villages would have leaders, one elder who was an advisor."
    },
    "438": {
        "startTime": 3007.282,
        "endTime": 3010.132,
        "transcript": "Tua-i tauna atanvagtun pitaluni.",
        "translation": "[S]he was like a great leader."
    },
    "439": {
        "startTime": 3011.162,
        "endTime": 3022.402,
        "transcript": "Tamarmeng nunarraat, tanglallruunga wii imumi uani-llu Napaskiarmi, nunarraat makut Ayalpiit tuaten un'gaa-i aptukait.",
        "translation": "Every village, I used to see them back then including downriver in Napaskiak, these villages, even what they call Ayalpiit downriver."
    },
    "440": {
        "startTime": 3024.197,
        "endTime": 3033.972,
        "transcript": "Ava-i cali qanertuten ayagyuat qanruyutnek niitnanrirniluki, makut pinrirniluki.",
        "translation": "You also just said that young people don't hear traditional wisdom anymore, that these people don't [instruct them] anymore."
    },
    "441": {
        "startTime": 3033.972,
        "endTime": 3037.042,
        "transcript": "Ciin tamana tuaten pia, piuga?",
        "translation": "Why is that the case?"
    },
    "442": {
        "startTime": 3037.472,
        "endTime": 3050.882,
        "transcript": "Tuaten piungan mat'um wani state pataqutakaakut wangkuta, waten qaingirluta.",
        "translation": "Since' it's like that, this state is going to take over us, superceding us like this."
    },
    "443": {
        "startTime": 3052.732,
        "endTime": 3059.252,
        "transcript": "Wangkuta wani ayagnillruukut mat'umek aprumalriamek Yup'ik Nation.",
        "translation": "We started this, what is called the Yup'ik Nation."
    },
    "444": {
        "startTime": 3059.297,
        "endTime": 3062.467,
        "transcript": "Nutemllarmek Yuuyaramek wii pila'arqa.",
        "translation": "I call it the Ancient Way of Life."
    },
    "445": {
        "startTime": 3062.857,
        "endTime": 3072.417,
        "transcript": "Tauna tua-i wani au͡g'umek qaneryugngaunga, \"Aatan aanan-llu niisngakek. Umyuan-llu aturpiiqnaku yuugi.\"",
        "translation": "I can say what I just said, \"Obey your father and mother. And quit living according to your every whim.\""
    },
    "446": {
        "startTime": 3072.592,
        "endTime": 3080.172,
        "transcript": "Maa-i wani kayuringuq wangni assiriuq uani Akiacuarmi.",
        "translation": "Now, it's becoming stronger and better to me downriver in Akiachak."
    },
    "447": {
        "startTime": 3080.397,
        "endTime": 3083.177,
        "transcript": "Tamaryarpiallruyaaquq.",
        "translation": "It was almost lost."
    },
    "448": {
        "startTime": 3083.522,
        "endTime": 3090.932,
        "transcript": "Tua-i-ll' tauna Willie tan'gaurluulria, nateqliqliu-ll', tayim' pitatekliken.",
        "translation": "Then Willie who is a boy, I'm not sure how far apart you are, probably the same age as you."
    },
    "449": {
        "startTime": 3091.992,
        "endTime": 3101.632,
        "transcript": "Makunek cali wangkuta qaneryaramteńek alerquutnek pitatni-llu, pitatainek council-aangqertua.",
        "translation": "We've [gone over] our language and traditional instructions with his peerson, his peers are also in my council."
    },
    "450": {
        "startTime": 3102.067,
        "endTime": 3106.167,
        "transcript": "Taukut wiinga umyuama peng'gartenrirai watua.",
        "translation": "In my mind, I don't worry about them now."
    },
    "451": {
        "startTime": 3106.797,
        "endTime": 3115.107,
        "transcript": "Tau͡gaam cali agyanek anuqnek-llu elitnauqsaitanka unguvayaranek.",
        "translation": "But I still haven't taught them about the stars and winds for survival."
    },
    "452": {
        "startTime": 3115.427,
        "endTime": 3121.397,
        "transcript": "Amlleq wani unguvayaraq cali paivcimaksaituq.",
        "translation": "Much of how to survival has still not been brought up."
    },
    "453": {
        "startTime": 3125.397,
        "endTime": 3132.777,
        "transcript": "Au͡g'umek paqnayungarcetavnga agyanek anuqnek-llu unguvayaranek. Kitak' qanrutkeqerru.",
        "translation": "You've made me curious about survival with the stars and winds. Please talk about it."
    },
    "454": {
        "startTime": 3132.777,
        "endTime": 3137.787,
        "transcript": "[Ukut wani] nallunritqapiararanka anuqet cetaman. Neqnguut.",
        "translation": "I know about [these] four winds very well. They are the harbingers of fish."
    },
    "455": {
        "startTime": 3139.037,
        "endTime": 3145.307,
        "transcript": "Neqet agiiruciat ukutgun kiagmi nallunritanka neqsurturatullruama.",
        "translation": "I know when the fish are coming int he summer through these because I would always fish."
    },
    "456": {
        "startTime": 3145.697,
        "endTime": 3149.057,
        "transcript": "Mikurarkauciat-llu nalluvkenaku.",
        "translation": "And I know if they're going to be abundant."
    },
    "457": {
        "startTime": 3149.432,
        "endTime": 3156.622,
        "transcript": "Anuqa atauciq neqaituq: una-gguq kanavaq.",
        "translation": "One wind direction heralds no fish: the one they call [?kanavaq]."
    },
    "458": {
        "startTime": 3157.502,
        "endTime": 3160.572,
        "transcript": "Manaryaaqsartuten, keggngaitut.",
        "translation": "You may fish, but they won't bite."
    },
    "459": {
        "startTime": 3161.672,
        "endTime": 3163.362,
        "transcript": "Tua-i taukut.",
        "translation": "Those are [the winds]."
    },
    "460": {
        "startTime": 3163.362,
        "endTime": 3166.272,
        "transcript": "Agyat-llu pagkut murilkeńarqut.",
        "translation": "You must also observe the stars up there."
    },
    "461": {
        "startTime": 3166.272,
        "endTime": 3173.722,
        "transcript": "Pikani ellam qukaani malrunlegnek agyartangqertuq uivelrianek cass'amek.",
        "translation": "Up in the middle of the sky, there are seven rotating stars to measure time."
    },
    "462": {
        "startTime": 3174.212,
        "endTime": 3184.512,
        "transcript": "Uivekuneng waten malrunelgen, ingna erneq caukagu, arulaiqain caumaurqaku",
        "translation": "When these seven rotate like this, if it faces the day[break] over there, if it stops and faces it"
    },
    "463": {
        "startTime": 3186.107,
        "endTime": 3193.437,
        "transcript": "Agyaq mayurciquq kiimi angenruluni tanqigceńani Erenret qamurluki.",
        "translation": "A star will rise, the only biggest and bright one, pulling up Erenret [Days - constellation?]."
    },
    "464": {
        "startTime": 3193.437,
        "endTime": 3196.477,
        "transcript": "Iqukliskuni-ll' tua-i Erenret alairluteng.",
        "translation": "Then when it ends, Erenret appear."
    },
    "465": {
        "startTime": 3196.922,
        "endTime": 3200.752,
        "transcript": "Tua-i tauna au͡gkut ciuliamta pekengyaraat.",
        "translation": "That was when our ancestors would start stirring."
    },
    "466": {
        "startTime": 3201.012,
        "endTime": 3206.592,
        "transcript": "Amci pinariniluku. Cassaitelallruameng-llu, cass'anek tangaaksaitelallruameng.",
        "translation": "They said it was time [to get up] now. Also, it was because they had no clocks, wouldn't see clocks."
    },
    "467": {
        "startTime": 3207.767,
        "endTime": 3215.507,
        "transcript": "Cali waten-qaa amlleqtaaquneng anuqlirarkauluteng. Anuqmun ataluteng.",
        "translation": "Also, if there are a lot like this, it will be windy. They are connected to the wind."
    },
    "468": {
        "startTime": 3215.682,
        "endTime": 3222.982,
        "transcript": "Tuaken-llu anuqlingraan pairrluku agyaq anaqan tuaken anuqengarkauluni.",
        "translation": "And even if it's windy from that direction, if the star goes past and there's a falling star, the wind will shift to there."
    },
    "469": {
        "startTime": 3223.297,
        "endTime": 3230.307,
        "transcript": "Makut maa-i imkut scientist-aanek pilaqait neqnek elisngalriit",
        "translation": "These people they call scientists who are knowledgeable about fish."
    },
    "470": {
        "startTime": 3231.157,
        "endTime": 3238.377,
        "transcript": "Wangkuta tamakuilengramta elisngaaput. Neqsurturatullruama-w' nallunrilkenka.",
        "translation": "Though we didn't have those, we are knowledgeable about them. Since I always fished, I know them."
    },
    "471": {
        "startTime": 3238.612,
        "endTime": 3247.802,
        "transcript": "Un'gani-ll' cali uitaqallret cali carvaniurluteng nalluvkenaki. Nallunaunateng.",
        "translation": "And I also know the ones who've stayed downriver in the currents. They are easy to tell."
    },
    "472": {
        "startTime": 3247.982,
        "endTime": 3253.352,
        "transcript": "Au͡gkunek tua-i elitnaullemnek, elitnaulallemnek-wa.",
        "translation": "Those are things I was taught, what I learned."
    },
    "473": {
        "startTime": 3254.262,
        "endTime": 3260.462,
        "transcript": "Up'nerkami cali anuqlirtura'arqami neqnek taicinilallruat.",
        "translation": "Also, when there kept being strong winds int he spring, they said it brought fish."
    },
    "474": {
        "startTime": 3261.337,
        "endTime": 3262.617,
        "transcript": "Tua-llu?",
        "translation": "How was that?"
    },
    "475": {
        "startTime": 3262.902,
        "endTime": 3270.952,
        "transcript": "Tua-i au͡gkut ava-i murilkellret. Ellam mat'um murilkellra assirtuq, ellamta.",
        "translation": "Those were things they observed back then. It's good to observe the world, our world."
    },
    "476": {
        "startTime": 3272.792,
        "endTime": 3278.402,
        "transcript": "Ii-i, camek allamek qaneryukuvet wall'u tua-i qanerkairuskuvet...",
        "translation": "Okay, if you want to say anything else, or if you have nothing left to say..."
    },
    "477": {
        "startTime": 3278.402,
        "endTime": 3288.172,
        "transcript": "Tua-i quyaqapigtua watua. Ilagaryuumilaryaaqamci waten mat'ukun nutemllarkun pinalua.",
        "translation": "I'm very thankful now. I yearn to join you like this to speak about our ancient traditions."
    },
    "478": {
        "startTime": 3288.202,
        "endTime": 3295.642,
        "transcript": "Imum-llu, pim, kituulria ima? Twitchell.",
        "translation": "And that guy, you know, who is he again? Twitchell."
    },
    "479": {
        "startTime": 3296.057,
        "endTime": 3300.347,
        "transcript": "Erinairyullruyaaqaanga tau͡gaam anelraqsailama piksaitaanga.",
        "translation": "He wanted to record me, but since I didn't go downriver, he didn't."
    },
    "480": {
        "startTime": 3302.217,
        "endTime": 3303.187,
        "transcript": "Willie...",
        "translation": "Willie..."
    },
    "481": {
        "startTime": 3310.347,
        "endTime": 3314.447,
        "transcript": "Willie, what's your view on the unification issue?",
        "translation": "Willie, what's your view on the unification issue?"
    },
    "482": {
        "startTime": 3314.982,
        "endTime": 3326.492,
        "transcript": "The unification issue has been a topic of discussion on AVCP's convention, I would guess for the last four to five years.",
        "translation": "The unification issue has been a topic of discussion on AVCP's convention, I would guess for the last four to five years."
    },
    "483": {
        "startTime": 3328.112,
        "endTime": 3340.172,
        "transcript": "I think it has made a slow progress, but nevertheless, it takes time to work on issues of relevance that affect the whole region.",
        "translation": "I think it has made a slow progress, but nevertheless, it takes time to work on issues of relevance that affect the whole region."
    },
    "484": {
        "startTime": 3340.927,
        "endTime": 3352.767,
        "transcript": "Just recently, prior to the convention, we had what we call a Unification Forum Meeting in Imangaq where the regional non-profits were invited.",
        "translation": "Just recently, prior to the convention, we had what we call a Unification Forum Meeting in Emmonak where the regional non-profits were invited."
    },
    "485": {
        "startTime": 3353.162,
        "endTime": 3366.722,
        "transcript": "And at that time, we discussed with Nunam Kellutestii, Ceńaliulriit, YKHC, AVCP, and Yupiit Nation",
        "translation": "And at that time, we discussed with Nunam Kellutestii, Ceńaliulriit, YKHC, AVCP, and Yupiit Nation"
    },
    "486": {
        "startTime": 3367.08,
        "endTime": 3379.32,
        "transcript": "About the unification process that AVCP has undertaken based up the directions that they received from Qipneq's convention resolution.",
        "translation": "About the unification process that AVCP has undertaken based up the directions that they received from Kipnuk's convention resolution."
    },
    "487": {
        "startTime": 3381.88,
        "endTime": 3393.69,
        "transcript": "At that time, we also understand that not many of the people in the villages really understood what the unification meant.",
        "translation": "At that time, we also understand that not many of the people in the villages really understood what the unification meant."
    },
    "488": {
        "startTime": 3394.87,
        "endTime": 3400.36,
        "transcript": "The unification that we're talking about is the development of the regional tribal government.",
        "translation": "The unification that we're talking about is the development of the regional tribal government."
    },
    "489": {
        "startTime": 3401.15,
        "endTime": 3408.25,
        "transcript": "So at the recommedations at the Imanagaq forum meeting was that",
        "translation": "So at the recommendations at the Emmonak forum meeting was that"
    },
    "490": {
        "startTime": 3408.47,
        "endTime": 3415.11,
        "transcript": "The non-profits each shall adopt a supporting resolution in concept.",
        "translation": "The non-profits each shall adopt a supporting resolution in concept."
    },
    "491": {
        "startTime": 3415.3,
        "endTime": 3420.54,
        "transcript": "And we did receive commitment from the organizations that were represented there.",
        "translation": "And we did receive commitment from the organizations that were represented there."
    },
    "492": {
        "startTime": 3421.03,
        "endTime": 3431.9,
        "transcript": "I believe one of the things that this convention will talk about, how to select people to sit on what it's called, the Constitutional Committee.",
        "translation": "I believe one of the things that this convention will talk about, how to select people to sit on what it's called, the Constitutional Committee."
    },
    "493": {
        "startTime": 3432.687,
        "endTime": 3448.662,
        "transcript": "The Constitutional Committee's task would be to review how the other Indigenous people in the United States, for that matter the whole world, organize under their own types of government.",
        "translation": "The Constitutional Committee's task would be to review how the other Indigenous people in the United States, for that matter the whole world, organize under their own types of government."
    },
    "494": {
        "startTime": 3449.62,
        "endTime": 3456.26,
        "transcript": "As stated, as I stated earlier, not everybody understands the tribal government issues.",
        "translation": "As stated, as I stated earlier, not everybody understands the tribal government issues."
    },
    "495": {
        "startTime": 3456.27,
        "endTime": 3461.52,
        "transcript": "So, one of the tasks of this committee would be to educate the people.",
        "translation": "So, one of the tasks of this committee would be to educate the people."
    },
    "496": {
        "startTime": 3461.53,
        "endTime": 3467.55,
        "transcript": "By that, I mean they will be traveling to regional centers to conduct series of public meetings",
        "translation": "By that, I mean they will be traveling to regional centers to conduct series of public meetings"
    },
    "497": {
        "startTime": 3467.56,
        "endTime": 3476.02,
        "transcript": "To get people to understand and up to speed of what we would like to achieve under the unification plan.",
        "translation": "To get people to understand and up to speed of what we would like to achieve under the unification plan."
    },
    "498": {
        "startTime": 3476.464,
        "endTime": 3480.285,
        "transcript": "I think one important thing about the unificationplan is",
        "translation": "I think one important thing about the unificationplan is"
    },
    "499": {
        "startTime": 3480.292,
        "endTime": 3489.721,
        "transcript": "That the organizations and their boards are not the individuals and the authority to develop this government.",
        "translation": "That the organizations and their boards are not the individuals and the authority to develop this government."
    },
    "500": {
        "startTime": 3490.042,
        "endTime": 3498.85,
        "transcript": "Ultimately, the people in the villages, those that have the voting rights will be the ones to vote on the issue",
        "translation": "Ultimately, the people in the villages, those that have the voting rights will be the ones to vote on the issue"
    },
    "501": {
        "startTime": 3499.372,
        "endTime": 3504.0,
        "transcript": "And then proceed with the development of a government.",
        "translation": "And then proceed with the development of a government."
    },
    "502": {
        "startTime": 3504.0,
        "endTime": 3511.057,
        "transcript": "You think you're going to see lot of support after this unification forum?",
        "translation": "You think you're going to see lot of support after this unification forum?"
    },
    "503": {
        "startTime": 3511.064,
        "endTime": 3515.349,
        "transcript": "I believe so, based on some of the comments that I heard.",
        "translation": "I believe so, based on some of the comments that I heard."
    },
    "504": {
        "startTime": 3515.357,
        "endTime": 3520.879,
        "transcript": "There's still a lot of questions that needs to be brought out and answered",
        "translation": "There's still a lot of questions that needs to be brought out and answered"
    },
    "505": {
        "startTime": 3520.886,
        "endTime": 3527.007,
        "transcript": "And we had a little bit of taste of that yesterday when I gave the Yupiit Nation report.",
        "translation": "And we had a little bit of taste of that yesterday when I gave the Yupiit Nation report."
    },
    "506": {
        "startTime": 3527.957,
        "endTime": 3534.05,
        "transcript": "I think especially the elders have already understood the concept",
        "translation": "I think especially the elders have already understood the concept"
    },
    "507": {
        "startTime": 3534.386,
        "endTime": 3539.064,
        "transcript": "But it's, from some of the comments that I've heard from the elders is that",
        "translation": "But it's, from some of the comments that I've heard from the elders is that"
    },
    "508": {
        "startTime": 3539.393,
        "endTime": 3547.107,
        "transcript": "These young people that are bilingual aren't too sure whether to go with the old ways or the new ways.",
        "translation": "These young people that are bilingual aren't too sure whether to go with the old ways or the new ways."
    },
    "509": {
        "startTime": 3547.114,
        "endTime": 3552.779,
        "transcript": "I think in developing a regional government under the unification process",
        "translation": "I think in developing a regional government under the unification process"
    },
    "510": {
        "startTime": 3553.007,
        "endTime": 3557.657,
        "transcript": "Both the old ways and the new ways needs to be incorporated",
        "translation": "Both the old ways and the new ways needs to be incorporated"
    },
    "511": {
        "startTime": 3557.664,
        "endTime": 3564.228,
        "transcript": "So that whatever comes about would best represent the people, and work for the people.",
        "translation": "So that whatever comes about would best represent the people, and work for the people."
    },
    "512": {
        "startTime": 3564.35,
        "endTime": 3565.707,
        "transcript": "One other question...",
        "translation": "One other question..."
    },
    "513": {
        "startTime": 3568.243,
        "endTime": 3571.1,
        "transcript": "Uptenrilnge'rpet-qaa? Ready-rtuq?",
        "translation": "Even if you don't prepare? is it ready?"
    },
    "514": {
        "startTime": 3571.729,
        "endTime": 3578.336,
        "transcript": "I don't think AVCP is boycotting not to rejoin AFN",
        "translation": "I don't think AVCP is boycotting not to rejoin AFN"
    },
    "515": {
        "startTime": 3578.564,
        "endTime": 3580.592,
        "transcript": "And, it's on the agenda.",
        "translation": "And, it's on the agenda."
    },
    "516": {
        "startTime": 3581.422,
        "endTime": 3590.514,
        "transcript": "I think what AVCP wants is true representation of our desires",
        "translation": "I think what AVCP wants is true representation of our desires"
    },
    "517": {
        "startTime": 3590.679,
        "endTime": 3594.179,
        "transcript": "If we are to go back to AFN.",
        "translation": "If we are to go back to AFN."
    },
    "518": {
        "startTime": 3594.75,
        "endTime": 3598.793,
        "transcript": "And, I think using the example of the 1991 process",
        "translation": "And, I think using the example of the 1991 process"
    },
    "519": {
        "startTime": 3599.493,
        "endTime": 3605.814,
        "transcript": "AVCP had some specific issues that we wanted AFN to address.",
        "translation": "AVCP had some specific issues that we wanted AFN to address."
    },
    "520": {
        "startTime": 3606.521,
        "endTime": 3611.786,
        "transcript": "But, on the 11th hour, our concerns weren't heard.",
        "translation": "But, on the 11th hour, our concerns weren't heard."
    },
    "521": {
        "startTime": 3611.872,
        "endTime": 3619.236,
        "transcript": "And for that reason, we did not go back to AFN, among others.",
        "translation": "And for that reason, we did not go back to AFN, among others."
    },
    "522": {
        "startTime": 3619.292,
        "endTime": 3621.521,
        "transcript": "That was the primary reason.",
        "translation": "That was the primary reason."
    },
    "523": {
        "startTime": 3621.528,
        "endTime": 3627.0,
        "transcript": "If AVCP is to rejoin AFN",
        "translation": "If AVCP is to rejoin AFN"
    },
    "524": {
        "startTime": 3627.107,
        "endTime": 3631.314,
        "transcript": "The AVCP leadership needs to sit down with AFN leadership",
        "translation": "The AVCP leadership needs to sit down with AFN leadership"
    },
    "525": {
        "startTime": 3631.343,
        "endTime": 3636.85,
        "transcript": "And discuss how representation would have to occur.",
        "translation": "And discuss how representation would have to occur."
    },
    "526": {
        "startTime": 3636.857,
        "endTime": 3643.25,
        "transcript": "And, AVCP needs to be involved in such a statewide organization.",
        "translation": "And, AVCP needs to be involved in such a statewide organization."
    },
    "527": {
        "startTime": 3644.721,
        "endTime": 3647.164,
        "transcript": "Do you have any additional comments you want to make?",
        "translation": "Do you have any additional comments you want to make?"
    },
    "528": {
        "startTime": 3648.886,
        "endTime": 3655.436,
        "transcript": "I guess as far as the convention here, the 25th Annual Convention of AVCP",
        "translation": "I guess as far as the convention here, the 25th Annual Convention of AVCP"
    },
    "529": {
        "startTime": 3655.721,
        "endTime": 3663.507,
        "transcript": "This, I view as a turning point where our people are beginning to understand",
        "translation": "This, I view as a turning point where our people are beginning to understand"
    },
    "530": {
        "startTime": 3663.514,
        "endTime": 3668.414,
        "transcript": "That we need to work together as a united group of villages.",
        "translation": "That we need to work together as a united group of villages."
    },
    "531": {
        "startTime": 3668.921,
        "endTime": 3678.35,
        "transcript": "Whatever form the unification comes out of, we need to support it individually and organizationally in order for it to succeed",
        "translation": "Whatever form the unification comes out of, we need to support it individually and organizationally in order for it to succeed"
    },
    "532": {
        "startTime": 3678.357,
        "endTime": 3680.507,
        "transcript": "For our desires.",
        "translation": "For our desires."
    },
    "533": {
        "startTime": 3680.936,
        "endTime": 3681.85,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "534": {
        "startTime": 3681.857,
        "endTime": 3682.729,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "535": {
        "startTime": 3682.735,
        "endTime": 3684.278,
        "transcript": "Yugtun-wa pinrilnguten.",
        "translation": "You should've spoke Yup'ik."
    },
    "536": {
        "startTime": 3684.286,
        "endTime": 3685.986,
        "transcript": "Canrituq au͡g'um cover-allrua.",
        "translation": "It's okay, [s]he just covered it."
    }
};